<template>
  <div class="top">
    <ul class="top-slides-bg-circles">
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
    </ul>
    <ul class="top-slides-bg-circles2">
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
    </ul>
    <v-container fluid>
      <div class="top-slides-bg" ref="getSlidesHeight">
        <div class="top-link">
          <v-row class="mt-5 music-story">
            <v-col cols="12"><p class="topic">Music-Story</p></v-col>
            <div class="my-8"></div>
            <v-col cols="0" sm="1" md="1" class="d-lg-none"></v-col>
            <v-col cols="12" sm="4" md="4" lg="5" xl="5" xxl="5" v-for="(item, i) in content" :key="i" class="">
              <v-img :src="item.src"></v-img>
              <p class="music-story-artwork">artwork:
                <a :href="item.artworkLink" target="_blank" v-if="item.artworkLink!==''">{{item.artworkBy}}</a>
                <span v-if="item.artworkLink===''">{{item.artworkBy}}</span>
              </p>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="7" xl="7" xxl="7" v-for="(item, i) in content" :key="i" class="d-flex flex-column justify-center">
              <p class="music-story-genre" :style="{color: item.color}">{{ item.genre }}</p>
              <p class="music-story-title">{{ item.title }}</p>
              <v-btn color="#f8c6c6" class="music-story-btn" :href="item.url" target="_blank" v-if="item.url!==''">Play<v-icon color=#222>mdi-menu-right</v-icon></v-btn>
              <v-card disabled color="transparent" class="music-story-btn" v-else></v-card>
            </v-col>
            <v-col cols="0" sm="1" md="1" class="d-lg-none"></v-col>
            <v-col cols="12" v-for="(item, i) in content" :key="i" class="">
              <p class="music-story-divider" style="padding-top:2rem">Concept</p>
              <p class="music-story-concept" v-html="TextDecorate(item.concept)"></p>
              <p class="music-story-divider">Detail</p>
              <div v-for="(detail, j) in item.detail" :key="j" class="music-story-detail">
                <p class="music-story-label">{{ detail.label }}</p>
                <p class="music-story-description" v-html="TextDecorate(detail.description)"></p>
              </div>
              <p class="music-story-divider">Story</p>
              <div class="music-story-text">
                <p class="music-story-main" v-html="TextDecorate(item.storyMain)"></p>
                <p v-if="item.storyComment!==''" class="music-story-comment">{{ item.storyComment }}</p>
                <p class="music-story-end">{{ item.storyEnd }}</p>
              </div>
            </v-col>
          </v-row>
        </div>
        <div class="py-12"></div>
        <v-btn color="#f8c6c6" class="music-story-back"><router-link to="/music">Back to MUSIC</router-link></v-btn>
        <div class="py-12"></div>
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  data: () => ({
    musics: [
      {
        url: "https://soundcloud.com/semicolon0103/tabiji-heno-shoukei",
        src: require("../assets/musics/Tabiji_heno_shoukei.webp"),
        genre: "MUSIC GAME",
        color: "#039BE5",
        title: "旅路への憧憬",
        text: "稚内を走りながら",
        date: "2022",
        story: "",
        artworkBy: "",
        artworkLink: "",
        concept: "",
        detail: [
          {
            label: "",
            description: "",
          },
          {
            label: "",
            description: "",
          },
          {
            label: "",
            description: "",
          },
        ],
        storyMain: "",
        storyComment: "",
        storyEnd: "",
      },
      {
        url: "",
        src: require("../assets/musics/_unpublished.webp"),
        genre: "MUSIC GAME",
        color: "#039BE5",
        title: "未公開曲 #1",
        text: "",
        date: "2022",
        story: "",
        artworkBy: "",
        artworkLink: "",
        concept: "",
        detail: [
          {
            label: "",
            description: "",
          },
          {
            label: "",
            description: "",
          },
          {
            label: "",
            description: "",
          },
        ],
        storyMain: "",
        storyComment: "",
        storyEnd: "",
      },
      {
        url: "https://d10rama.com/nitousei/",
        src: require("../assets/musics/Nitousei.webp"),
        genre: "VISUAL NOVEL",
        color: "#D81B60",
        title: "みえない二等星",
        text: "ギターとの和解",
        date: "2022",
        story: "",
        artworkBy: "",
        artworkLink: "",
        concept: "",
        detail: [
          {
            label: "",
            description: "",
          },
          {
            label: "",
            description: "",
          },
          {
            label: "",
            description: "",
          },
        ],
        storyMain: "",
        storyComment: "",
        storyEnd: "",
      },
      {
        url: "https://soundcloud.com/semicolon0103/graduate-nekochan",
        src: require("../assets/musics/Graduate_Nekochan.webp"),
        genre: "MUSIC GAME",
        color: "#039BE5",
        title: "Graduate Nekochan",
        text: "卒業ソング",
        date: "2022",
        story: "",
        artworkBy: "",
        artworkLink: "",
        concept: "",
        detail: [
          {
            label: "",
            description: "",
          },
          {
            label: "",
            description: "",
          },
          {
            label: "",
            description: "",
          },
        ],
        storyMain: "",
        storyComment: "",
        storyEnd: "",
      },
      {
        url: "",
        src: require("../assets/musics/Yuuoumaishin.webp"),
        genre: "MUSIC GAME",
        color: "#039BE5",
        title: "勈徃邁進",
        text: "50時間くらいで作った和風なやつ",
        date: "2022",
        story: "",
        artworkBy: "",
        artworkLink: "",
        concept: "",
        detail: [
          {
            label: "",
            description: "",
          },
          {
            label: "",
            description: "",
          },
          {
            label: "",
            description: "",
          },
        ],
        storyMain: "",
        storyComment: "",
        storyEnd: "",
      },
      {
        url: "https://soundcloud.com/semicolon0103/lemonadegrenade",
        src: require("../assets/musics/Lemonadegrenade.webp"),
        genre: "MUSIC GAME",
        color: "#039BE5",
        title: "Lemonadegrenade",
        text: "本気でクラシックに全振り",
        date: "2021",
        story: "Lemonadegrenade",
        artworkBy: "いもねぎ",
        artworkLink: "https://twitter.com/imonegi_48",
        concept: "クラシック趣味が炸裂した曲\n純度100%の生楽器で奏でる交響詩",
        detail: [
          {
            label: "イントロ",
            description: "物静かに進軍する様を描く。\nラヴェルリスペクトの、小鳥のさえずりみたいなピッコロが鳴ると\n木管楽器達の重奏が始まり、徐々に盛り上がりを見せていく。\nトランペットのファンファーレを迎え、そのままAメロへ",
          },
          {
            label: "Aメロ",
            description: "クラシカル味とポピュラー味を混ぜたような和声で勇ましく進む様子を描く。\n合いの手みたいにトランペットのファンファーレを鳴らすの好き。\n裏コードからのドミナント、そのまま終止せずBメロへ。\nここは勢いで書いたのでこの和声的解釈が合ってるかは私もわからない。",
          },
          {
            label: "Bメロ",
            description: "木管楽器達とホルン3本の掛け合いパート。\n突き進んでいる様子を俯瞰的に眺めているイメージ。\nその後トランペットを迎え、イントロ最後のファンファーレを発展させてそのままサビへ。",
          },
          {
            label: "サビ",
            description: "イントロ以来の主旋律の出現。これがやりたかった。\n王者の帰還って感じが出て個人的に大好きな展開。\nBメロで掛け合いしてた木管楽器とホルンが主旋律を一緒に奏で、一体感を出す。\nトランペットはやっぱりバックコーラス的な使い方の方が良い気がしてきた。",
          },
          {
            label: "アウトロ",
            description: "四度堆積。ハチャトゥリアンの交響曲3番( https://www.nicovideo.jp/watch/sm11454502 )リスペクト。\nあちらの曲はトランペット18本とかいう規格外の編成だが本曲はチューバ1本トロンボーン3本トランペット3本なので演奏はしやすい方の部類。だと思う\nそのまま勇ましくパッと終止。",
          },
        ],
        storyMain: "こんな音ゲー曲、過去にあっただろうか、多分無いと断言していい。\n100%生楽器で構成されたPopping Nekochanで味を占めた私は、クラシック全振りのカッコいい感じの曲を作ろうと思い、着手。\nインプットしてきた無数の曲達から着想を得て、苦難の末に完成。\n基本的に私は作曲で苦しまないタイプなんですが、この曲は結構苦戦しました。\nあまり目立たないんですが、木管楽器の重奏は特に苦戦しました。\nまた、クラシック音楽に合うような打楽器パートの打ち込みは、電子音楽と異なる点が多く、己の信じる道を突き進む感じがありました。\nやりたい放題、惜しみなく趣味炸裂できたので本当に楽しかったです。\n\n私の勉強不足もあり、目立ってはいませんが詰め切れなかった部位が実はあります。\nただ、現状の私が持つ技術を全てぶつけられたので悔いはありません。今後の伸びしろということで。\nまたこの曲、イントロとサビ以外で目立った主旋律を鳴らしていません。\nクラシック音楽あるあるの展開ではありますが、旋律があるはずの音域が空にならないよう如何に楽器達を掛け合いさせるかも、工夫した点です。\n\n\n…DETAIL項に貼ったリスペクト曲、ハチャトゥリアンの交響曲3番について折角なんで書かせて？\nこの曲との出会いは、私が小学五年生の時でした。\n当時、モーツァルトやベートーベンあたりの有名どころしか実家のコンポで流れてなかったんですね。\nこれは間違いなく、「とりあえずクラシック音楽の王道から踏み外すな」という両親の思惑でしょう。\nしかしちょうどそのころ、偶然私がハチャトゥリアンのピアノ小作品を弾くことになり、それを聞いた父が得意げにハチャトゥリアンのCDを複数枚持って来たんですね。(何故？)\n当然私もそれに興味を示して、擦り減るくらい聞き込んだわけですが、そのCDに入っていたのがあの曲。破天荒なパイプオルガンのトッカータに加え、上述の通り18本のトランペットによる四度堆積の狂暴なファンファーレに度肝を抜かしたものです。\n(ちなみに、そのファンファーレはここ( https://nico.ms/sm11454502?from=237 )(3:57～)から聴けます。)\n「なんだこれは」と衝撃を受け、実家のコンポの前で約30分間固まっていたのは懐かしい思い出です。\nこの音源、私も持っていますが、数ある音源の中で間違いなく最強かつ最恐の音源でしょう。\n是非聞いてみてください。\n\nさて、そんな若い頃に外れ値も良いところの強烈な作品に出会ってしまった、わたくし相生あおは。\nそこから、ショスタコーヴィチ、ラヴェル、ドビュッシーと順調に近現代の作曲家の作品にハマっていき見事王道から足を踏み外してしまい、今に至ります。\nなお王道の和声は大学入学後に先輩から教わりました。逆だわ普通。\nちなみに母には面白がられ、父には呆れられながらも、\n帰省した時とかはショスタコーヴィチ談義で私と盛り上がります。ウケる。\nすみません、ちょっと本筋から離れすぎたのでこの辺りでこの話は終わりにします。\n\nLemonadegrenadeに話を戻します。\nこの曲は5拍子、BPMは5/4拍子換算で280。かなり破天荒です。\n3作品を通し、思ったより5拍子が身に馴染んでしまったので、これからも書く機会があるかもしれません。\nちなみにこの曲名、私が冷凍庫でラムネ瓶を破裂させてしまった話に由来します(※偶発事故です)。\nあれは2017年の話ですが、\"冷凍庫 ラムネ\"とかでググれば2022年現在の今でもフツーにヒットします、はあ。\nでもそれを知れば、ジャケットへの理解がきっと深まることでしょう。\n\n\nここで、ジャケットを担当してくださったいもねぎさんからお話を頂きましたので\nそちらを紹介させていただき結ぼうと思います。",
        storyComment: "担いでるライフルは｢モシン・ナガン｣というソ連だかロシアだかで作られたやつです。\n引き金を引くと弾が出るらしいですよ。コ ワ いですねえ。",
        storyEnd: "コ ワ いなぁ…",
      },
      {
        url: "https://soundcloud.com/semicolon0103/frontier-nekochan",
        src: require("../assets/musics/Frontier_Nekochan.webp"),
        genre: "MUSIC GAME",
        color: "#039BE5",
        title: "Frontier Nekochan",
        text: "電子音と生楽器を融合",
        date: "2021",
        story: "Frontier_Nekochan",
        artworkBy: "umr",
        artworkLink: "https://twitter.com/BlazeConductor",
        concept: "作曲6年目の節目となるNekochan曲\n電子音と生楽器の融合を目指した",
        detail: [
          {
            label: "イントロ",
            description: "穏やかなキラキラ感から一転、目まぐるしくもナチュラルな転調を挟み、\n分数augを越えた先に王道的な盛り上がりを見せる。\n旋律を吹かされがちなトランペット達には、\n私としてはファンファーレを吹いて欲しいものです。\nNekochanの究極形態ここに在り。",
          },
          {
            label: "Aメロ",
            description: "ザ・Nekochan曲。和声が若干クラシック寄りになってるけど\nきっと許されると思ってる。\nコードに合わせてピアノを荒ぶらせるのも\n私の専売特許にしたい所存。\n後半部ではaugを連発して神秘的な感じを醸す。\nごくわずかにドビュッシー味がある気がする。",
          },
          {
            label: "Bメロ",
            description: "まさかの6拍子。4つ打ちが続いたNekochan曲も転換点？\nここの和声はFiercenessを参考にツーファイブっぽく。\n分数augの所では不安定感を増すため一時的に変拍子。\nその後は徐々に盛り上げ、トランペットのファンファーレ。\nただしサビ前に「待て」。歯切れを良くした打楽器パートを経てサビへ突っ走る。\n裏返ってるようなトランペットのグリッサンドは地味ながらこだわりポイント。",
          },
          {
            label: "サビ",
            description: "分数augでサビを始めたいお年頃。まずはピッコロソロで暴れさせる。\nその後はピアノも合流。いつものNekochan。\n荒ぶるピアノとトランペットのファンファーレと共に曲全体の盛り上がりを形成させる。\n後半部の上昇進行はAsteroid Nekochanリスペクト。\nその後はBメロ最後で出てきた打楽器パートを再現。Popping Nekochanで味を占めた技法。",
          },
          {
            label: "アウトロ",
            description: "帰ろ帰ろおうちに帰ろうって感じのコード進行を意識(?)\naugとかを挟みながら突き進み、徐々に上昇させていき\nシンバルが鳴る小節の1つ前の小節の最終拍目にトライアングルを鳴らし、\n壮大にフィナーレ。節目の曲らしい結びになったかと。",
          },
        ],
        storyMain: "帰ろ帰ろおうちに帰ろうって感じのコード進行を意識(?)\naugとかを挟みながら突き進み、徐々に上昇させていき\nシンバルが鳴る小節の1つ前の小節の最終拍目にトライアングルを鳴らし、\n壮大にフィナーレ。節目の曲らしい結びになったかと。音ゲー曲は2018年デビューなんですが、作曲自体は2016年。\n大学一年で始めた作曲ですが、学生最後の修士二年という節目のこの2021年に\n集大成的な曲を作ろうと思ったのがきっかけです。\n私らしさと言ったらNekochan曲で間違いないので、それを主軸にして\n今までの曲の系譜を汲んだ曲を作ろうとしました。\n特に生産者表示がなされてるタイプの曲に仕上がっていると思います。\n声部も適度にシンプルに仕上げ、楽器法に基づき音色の厚みを出しても音の情報量を適度に抑えるなど、\n気づかれなそうなところまで結構気を配りながら作った曲でもあります。\n当初の目標は達成されたと自負しています。\n\nマジどうでもいい話で恐縮なんですけど、この曲もスケジュールに追われたタイプの曲です。\n納期の辺りにまた北海道滞在することになってたんですね。10日くらいだったっけな。\n修論もあるのに旅行してんじゃないって話ですが、北の大地に呼ばれた気がしたので仕方ありません。\n旅先での作曲は流石に機材的に不可能なので、逆算すると出発前に仕上げる必要が出てきて。\n研究室の方のシミュレーションとかデータ解析とかにも追われてて死に物狂いで書き上げたのがこの曲です。\n滞在先の稚内市から研究報告会(オンライン)に参戦したのは今でもいい思い出です。\n卒業後、ドクターの先輩にこっそり聞いたらバレてなかったのでセーフです。\n非常に充実した日々だったと思います。本当に楽しかった。またやりたいかも。\n\n\nここで、ジャケットを担当してくださったumrさんからお話を頂きましたので\nそちらを紹介させていただき結ぼうと思います。",
        storyComment: "今作でNekochanシリーズを担当するのは3回目になります。\nシリーズ特有の「疾走感」と「爽快感」は殺さないように、全体としてなるべく可愛くなるように頑張りました！\nまた、今回はいもねぎさんの描くあの子をお借りして描かせて頂きました！\nトニカクカワイイ！次描く時もこのキャラで描きたいですね…！\n今見るとFrontier感が完全に迷子ですね…（これじゃSpace catですね笑 笑じゃないが）\nとても楽しかったです〜！またよろしくお願いします！",
        storyEnd: "ありがとうございました！",
      },
      {
        url: "https://d10rama.com/amehazu/",
        src: require("../assets/musics/Amehazu.webp"),
        genre: "VISUAL NOVEL",
        color: "#D81B60",
        title: "雨にして人を外れ",
        text: "ピアノ基調でしっとりと",
        date: "2021",
        story: "",
        artworkBy: "",
        artworkLink: "",
        concept: "",
        detail: [
          {
            label: "",
            description: "",
          },
          {
            label: "",
            description: "",
          },
          {
            label: "",
            description: "",
          },
        ],
        storyMain: "",
        storyComment: "",
        storyEnd: "",
      },
      {
        url: "https://soundcloud.com/semicolon0103/nightlude",
        src: require("../assets/musics/Nightlude.webp"),
        genre: "MUSIC GAME",
        color: "#039BE5",
        title: "Nightlude",
        text: "可憐な舞",
        date: "2021",
        story: "Nightlude",
        artworkBy: "MillQlair",
        artworkLink: "",
        concept: "優しさ全振りの音ゲー曲\n粉雪の下の舞踏をイメージした",
        detail: [
          {
            label: "イントロ",
            description: "出だしから優しさ100%\nこういう雰囲気が大好きなんですよ。",
          },
          {
            label: "Aメロ",
            description: "旋律は緩やかに上昇。伴奏は変な小細工はしない。着飾らないイメージ。\n後半部手前で一旦augを挟んで句点を打つ。\nグロッケンを一部だけで鳴らしたり、\n旋律と副旋律がカノン風になるようにしたり、\nとにかく優しさを意識した。",
          },
          {
            label: "Bメロ",
            description: "正直、ここを聞きながら寝てほしい。\nピアノの右手部は和音ではなく、敢えて2音だけを鳴らす。\n楽器構成がシンプルな曲は最低限度の音だけで構成されるべし。\nサビ直前に分数augを置いたけど、そんな奇をてらった使い方じゃないはず。",
          },
          {
            label: "サビ",
            description: "優雅に踊っている主人公が「あのねっあのねっ」とこちらを伺うイメージ。\n途中に弦楽器のトレモロが入る部分とか、ちょっとした歌劇感を狙ってみた。\n全体としてはワルツみたいな雰囲気を出せたかと。自信作。",
          },
          {
            label: "アウトロ",
            description: "ピアノメインで古風な感じで優雅に終止。\n幼少期に弾いてたピアノ練習曲の記憶がここで間違いなく生きている。",
          },
        ],
        storyMain: "変拍子に続き、今度は優しさ全振りの曲を書く機会がありました。\n長年そういう音ゲー曲を作りたかったので嬉々としてエントリー。\nBPMも二桁。トラック数も結構少ない部類。\nただし、楽器構成がシンプルなほど、無駄をそぎ落とす必要があるんですね。\n声部の動きを意識したり、根音の3倍音に相当する完全5度の音を抜かして共鳴を抑えたり。\n和声的なところで工夫を必要とするタイプの曲になるので、\n私としてもとても作り甲斐があり特に楽しいタイプの部類です。\n\n話は逸れますが、私はこういった構成がシンプルな曲の方が向いているっぽいです(多分)。\n現在、私が全BGMを担当した『雨にして人を外れ』( https://store.steampowered.com/app/2168610/_/ )がsteamで配信中でして。\nこのNightludeさながら、無駄を削ぎ落したタイプの曲盛りだくさんとなっております。\nさてですね、頂いたレビューの中に、曲をべた褒めしてくださってるものがありまして。\n和声的にごまかしが効かないタイプの曲を気に入って下さり、\nまことに、和声派作曲者冥利に尽きる限りです。こちらこそ本当にありがとうございます。\n音色面は和声面とは異なり正直課金でどうにかなる節があるので、\n土台である和声を先に固めたいという私の長年の想いが叶ったのかもしれません。わーい\nそろそろ音色面へ手を出していく頃合いでしょうか。さてさて…。",
        storyComment: "",
        storyEnd: "",
      },
      {
        url: "",
        src: require("../assets/musics/Knitefight.webp"),
        genre: "MUSIC GAME",
        color: "#039BE5",
        title: "Knitefight",
        text: "戦う騎士",
        date: "2021",
        story: "Knitefight",
        artworkBy: "NAREU.",
        artworkLink: "https://twitter.com/4444_Exxxx",
        concept: "音ゲー尺として2作目の変拍子曲\n5拍子の波に身を任せ一気に作った",
        detail: [
          {
            label: "イントロ",
            description: "壮大な戦闘曲をイメージ。\n打楽器隊のリズムのひらめきは自分でもよくわからない。\nGlittemとは異なり1小節完結タイプにしたけど\n変拍子を馴染ませることに成功できたと思ってる。",
          },
          {
            label: "Aメロ",
            description: "3+2タイプの5拍子。サビ前の前菜を意識し、勢いを維持したまま突き進むイメージ。",
          },
          {
            label: "Bメロ",
            description: "一旦ピアノとピッコロメインのパート。嵐の前の静けさをイメージ。\nピアノのテンションノートが気に入ってる。\nこういうところでオーボエで切なげな旋律を奏でさせるのが大好き。\nサビ前は弦楽器のストリングにスネアのトレモロを重ねる。\ndimの構成音を徐々に鳴らすだけでも結構高揚感を煽れるかもしれない。",
          },
          {
            label: "サビ",
            description: "近年稀にみるこだわりポイントがあるパート。\n低音パートに旋律を奏でさせ、進むにつれその旋律を全体が奏でる。\n旋律を鳴らしがちなトランペットたちには敢えて和音を鳴らせ、型破りを極めた。\nこの旋律は、半分はノリ、半分は考えたもの。\n音の動きが大きな山になるイメージで作った。\n汎用性が低い技法だけど、適材適所で使っていきたい。",
          },
          {
            label: "アウトロ",
            description: "イントロの発展系。最後は謎の変則リズムで勇ましく〆。\nあとこれ私よくやるんですけど、\nシンバルが鳴る小節の1つ前の小節の最終拍目にトライアングルを鳴らしがち。\nあまり見かけない技法なので、専売特許にしていきたい所存。",
          },
        ],
        storyMain: "Glittemを納品した後、主催側にエントリー数を聞いたところ\n曲数が少ないみたいな話を聞いたので、5拍子波が来ていた勢いで追加納品。\nGlittemがオシャレ全振りの曲になったので、雰囲気を対極にしようと考えた結果、戦闘曲風に。\n作曲黎明期にゲームBGMの戦闘曲を書いてた頃の記憶が蘇っているような感じに仕上がりました。\n\nバリバリ電子音みたいな曲と相性が悪い変拍子ですが、\n生楽器を添えてクラシック要素を加えてあげると途端に作りやすくなる感じがしました。\n電子音と生楽器のいいとこどりをした曲をこれからも作っていきたいですね。\nこの曲に関しては生楽器メインで電子音が添えられてる感じがするけど、\nまぁ音楽に正解は無いのですからよしとしましょう。\n\n\nここで、ジャケットを担当してくださったNAREU.さんからお話を頂きましたので\nそちらを紹介させていただき結ぼうと思います。",
        storyComment: "初めての方もいつもの方もどうもなれう。です。\nKnitefightでなんと今回はなんと！なんと！\n人生で初めて馬を描きました！\nめちゃくちゃ凝視しました、初めてにしては上手馬うまー(自己満)\n\n騎士をイメージしてキャラデザし、差分で色が違います。\n誕生や光の明るさ 繁栄と富の黄色 葛藤の夜 戦いの赤\n差分によって世界観を感じてもらえたらなと思います！！(編者注: 楽曲の収録パッケージでご確認ください。)\n今回はありがとうございました！",
        storyEnd: "こちらこそありがとうございました！",
      },
      {
        url: "",
        src: require("../assets/musics/Glittem.webp"),
        genre: "MUSIC GAME",
        color: "#039BE5",
        title: "Glittem",
        text: "オシャンなバー",
        date: "2021",
        story: "Glittem",
        artworkBy: "紫餅",
        artworkLink: "https://twitter.com/shihei_lileep",
        concept: "音ゲー尺としては初の変拍子曲\n5拍子の曲をたくさん聞きながら作った",
        detail: [
          {
            label: "イントロ",
            description: "この曲の旋律は結構苦労して考えたもの。\n5拍子はインプット量が少ないため、如何にそれっぽく聞こえるかを試みた。\n2小節でワンセットになるように作り、無理矢理感を無くした。\n旋律の動きは4拍子曲と共通なので、その記憶を辿って練った。",
          },
          {
            label: "Aメロ",
            description: "旋律はイントロ準拠。雰囲気が思ったよりオシャンティーだったので、\nシャレオツ全振りの雰囲気を目指した。\n後半のピアノソロは自分でも発想が分からない。" + "偶然性の音楽。".strike() + "\n自分の過去曲を振り返るとこんな雰囲気の曲はあまりないので\n多分何かが降臨していたんじゃないかな知らんけど",
          },
          {
            label: "Bメロ",
            description: "シャレオツ全振り曲の落ち着いた部位。多分これが模範解答？\nこれからサビが来るという高揚感を徐々に煽る感じ。\n弦楽器組のトリル奏法はやっぱり効果的だと思った。\n保続低音を使いながら退廃的ではないタイプの上昇進行を組み合わせた。",
          },
          {
            label: "サビ",
            description: "盛り上がるというより、華やかさを意識。\nこれまでのパートを継承してそのまま作った。\naug/分数augを多めに使い、浮遊感に似た非日常感を演出したつもり。\nアウトロは設けず、和声と旋律で終わりを予感させそのままサッと終止。",
          },
        ],
        storyMain: "変拍子曲を作る機会があったんですね。変拍子は2016年あたりにいろいろ試した経験があり\n5+6の11拍子が想像以上に綺麗に決まった記憶があったため参戦。\nただ5+6なんてトリッキーなことをすると、譜面制作者側が絶対苦労されると思ったので\n簡易化して5拍子に。そもそも音ゲーで変拍子ってあまりないですよね。\n\n横道にそれますが、クラシック畑を見渡すと結構変拍子は多く使われているんです。\n今回私が比較的サッと作れたのも、変拍子に馴染みがあるクラシック畑出身だったからなのかな～とか思います。\n例えばムソルグスキー作曲の『展覧会の絵』( https://www.youtube.com/watch?v=HLB4hjqgSRw )のプロムナード(この音源、最強なので是非最後まで聴いてください)。\nこの曲に関して語りたいことがあるんですけど、それすると脱線も良いところなので別の所でいずれするかも。\nさて閑話休題、この曲、サラッと聞き流してしまいそうですが、\n拍子を取ってみようとすると5+6の変拍子なんですよね。\nこの、サラッと受け入れられてしまうけど実はすごい変拍子。私のあこがれです。\n今回の曲みたいに、一貫して5拍子なんてしちゃうと気づかれちゃうんですけど、\n「わざわざ変拍子にする必要ないじゃん」と思われない曲に仕上がってれば幸いですね。\n\nこのように変拍子というものから、4拍子もとい4つ打ちとは違い、踊っている感じは伝わりますでしょうか。\n変拍子が多く使われる民族音楽、元をたどると舞踏曲であることが多いです。\n4つ打ちで踊り続けるより、変則的にした方が面白いと人間が感じるというのは、この辺りの史実に明らかです。\nそもそも変拍子というのは、4拍子(もしくは3拍子)をメジャーとした今の世界線目線の表現ですので、\n視野を広げれば、我々が変拍子と言ってる曲の方が音楽の\"源流\"なのでは、と私は思います。\n\n\nここで、ジャケットを担当してくださった紫餅さんからお話を頂きましたので\nそちらを紹介させていただき結ぼうと思います。",
        storyComment: "元々あおはさんとしてはラフを見て修正を出して……という感じで作業を進めたかったらしいのですが、\n私はイラストレーターではなくアブストオタクなので、\nラフも無しに作り始めて良い感じになるまで弄り回す、というのが普段の作り方でした。\nなのであおはさんのイメージと遠かった場合には全修正も覚悟の上で最初っから完成品を提出したところ、\n解釈一致だったらしくそのまま採用されました。ありがたや。\n\nさて肝心の作品に関して、｢夜景が見えるバーで語らっているイメージ｣といったことだったのでグラスを2つ並べてこんな感じになりました。\nちゃんと語らってる人間のイラストが描ける手腕があればなぁなどと作った当時は思っていたものの、\n今こうして見るとこれはこれで雰囲気があって良い感じになってますね。\n自分でも割とお気に入りなのであおはさんのオシャンティーな楽曲共々可愛がってやってもらえると嬉しいです(？)",
        storyEnd: "ありがとうございました！",
      },
      {
        url: "https://soundcloud.com/semicolon0103/suzume-no-sekai",
        src: require("../assets/musics/Suzume_no_sekai.webp"),
        genre: "MUSIC GAME",
        color: "#039BE5",
        title: "スズメノセカイ",
        text: "実は自分を重ねてる",
        date: "2021",
        story: "Suzume_no_sekai",
        artworkBy: "洛葉みかん",
        artworkLink: "https://twitter.com/lac_ba_m",
        concept: "キャラパケ第3弾\nキャラ設定が私と類似してたので好き勝手暴れた",
        detail: [
          {
            label: "イントロ",
            description: "手癖旋律。動きが快活な旋律は眠い時に降ってきがち。\n旋律は変えずに伴奏部のコードを変えるのがマイブームなので、やった。\nその後は旋律を発展させ、コードはまた手癖。\nマジで生産者表示。",
          },
          {
            label: "Aメロ",
            description: "旋律はイントロ準拠。あまり盛り上げるのもアレなので、\nイントロをさらに発展させる程度に。\nBメロに繋がる部分のファンタジー感は個人的にも大のお気に入り。",
          },
          {
            label: "Bメロ",
            description: "気まぐれドジっ子みたいな一面もあるとのことだったので、\n落ち着いた様子を表現。音価を長くすれば簡単に表現できる。\nサビ前の部分は最近よくやる、盛り上がり前の準備体操みたいな感じに仕上げた。\n変則的なリズムに仕上げてみたけど、聞き手側にどう届いていることやら。",
          },
          {
            label: "サビ",
            description: "イントロから使ってる旋律をトランペットたちが華々しく奏でる。\n後半はNekochanの系譜を感じる暴れ方。キャラ設定的に解放してもまぁいいでしょう。\nアウトロに繋がる部位は変則的なリズムを簡易化して再度引用。",
          },
          {
            label: "アウトロ",
            description: "フルート、いいですよね\n静かにシャットダウンしていくイメージ。",
          },
        ],
        storyMain: "確かこのときは冬の北海道と山陰地方から帰って来たばかりだったと記憶。\nそのため実作業時間は3日程度だったんじゃないかな。\nただ北海道に行く前には4曲を同時並行で作ってたので、\n期日が一番後だったこの曲は鳥取砂丘から戻って来た後にせざるを得なかったというわけです。\n無計画にいろいろ参加しすぎたのは反省ですが、期日通りにちゃんとしたものを納品できたので結果オーライです。\n\n私は明るい曲も重く暗い曲も関係なく書くタイプなんですが、\nこの曲みたいに楽しさ全振りみたいな曲を書いてる時が、なんだかんだ気分がノって来て楽しい気がします。\n作曲の引き出しは出来るだけ多くしておきたいものです。\n\n\nここで、ジャケットを担当してくださった洛葉みかんさんからお話を頂きましたので\nそちらを紹介させていただき結ぼうと思います。",
        storyComment: "洛葉みかんです。名前は「らくばみかん」と読みます。\nスズメノセカイのジャケットを描かせていただくにあたって、\nおもちゃ箱から飛び出るような感じをイメージして描かせていただきました。\nスズメちゃん（ジャケットの子）も可愛がっていただければ嬉しいです。",
        storyEnd: "ありがとうございました！",
      },
      {
        url: "https://soundcloud.com/semicolon0103/electrical-toxic",
        src: require("../assets/musics/Electrical_Toxic.webp"),
        genre: "MUSIC GAME",
        color: "#039BE5",
        title: "エレクトリカル・トキシック",
        text: "栄枯盛衰を曲に",
        date: "2021",
        story: "Electorical_Toxic",
        artworkBy: "しりあ",
        artworkLink: "https://twitter.com/Celia_oekaki",
        concept: "ストーリーをそのまま曲の展開で表現した。\nまたピアノを伴奏にも充て、新たな利用可能性を探った。",
        detail: [
          {
            label: "イントロ",
            description: "非常に珍しくベースライン先行で作った。詳細は後述するが、\n代案が閃かず悶えていたらダンスホールチックな構想が降ってきたので採用。\nストーリー設定的にチェンバロを加えた方がいいと思い、少し中世感を出した。\nリバースピアノの入りはかなり気に入っている。天才かもしれない。\nこの辺りは、何かの物語のOPでカメラが上にゆっくりパンして\nタイトルがゆっくり出てくる感を意識した。実は今作はMVを付けたい曲筆頭だったりする。\n最後の全音音階は手癖。浮世離れした感じが出てそれほど場違いでは無いかと。",
          },
          {
            label: "Aメロ(コード)",
            description: "あまりちょこまか動かすのは雰囲気に合わないので、\n保続低音を意識した下降進行にした。\n聞き覚えがあるが元ネタを思い出せないためこれも多分手癖。",
          },
          {
            label: "Aメロ(旋律)",
            description: "物悲しいメロディという注文があったため、この世の悲哀を歌う旋律を目指した。\n旋律的短音階を使うことで物悲しさを出し、ストーリー設定に沿うようにした。",
          },
          {
            label: "Bメロ",
            description: "閃かなかったのでOperonのAメロをそのまま持ってきた。ごめんなさい\nただ注文書にピアノが鳴っている感じとあった上に寂しい感じにも聞こえるので、雰囲気的には抜擢かと。\n短期間に一気に作ると構想の泉が一時的に枯渇してしまうので難しい。\nまた注文書には、少し希望が持てる感じ的なニュアンスがあったので、\nサビでそれを実現すべく後半部は雲の切れ目から光が差し込むイメージを目指した。",
          },
          {
            label: "サビ",
            description: "ここで一旦ハ長調っぽくし、在りし日の活躍する姿を描いた。\nコードは変なことはせず、旋律はAメロを基調に明るめにアレンジして鳴らした。\n合いの手でチェンバロを鳴らしたのはイントロと同じ理由。\nただここは本当はイ短調。短調であることを明らかにし雲行きを怪しくする。\n現実には敵わない一縷の望みとはこういう感じだろう。",
          },
          {
            label: "アウトロ",
            description: "残酷な現実を前に、希望もろとも切なく散っていく様を描写した。\nDaydreamと同じようにドミナントで半終止させることで敢えて心残り感を出した。\nまるで雨上がりの黄土色の雲の切れ目から差し込む一筋の光をバックに\n\"何か\"が散って消えていくようにウィンドチャイムで締めた。",
          },
        ],
        storyMain: "夢色の花束に続きキャラパケ参加曲2曲目です。この曲をなぜ選んだかというと\n注文書にあった目安ジャンルにある\"フルオン\"をフルオーケストラと勘違いして安易に「作れそう！」と思ったからなんです。\nただ、曲出したら注文に合わない言われて散々リテイク喰らったという嫌な思い出が別の所で過去にあったため、\n仮組み状態から作り上げる前に一度主催の方に確認を取ったんです。\nしたら「そこまで逸脱しちゃうのはちょっと…」と言われました。なんとな～くそんな気はしていました。\nさてこうなったら大変、仮組みしていた案が使えなくなったということで、一から作り直しです。\nこれはジャンルを確認しなかった私が明らかに悪いのです、ちゃぶ台返しは当然。下調べはちゃんとしましょう…\nこの頃作った曲の記事にも書いてありますが、この時期は一ヵ月で5曲作る必要があり、\nじっくり一曲に専念して考える余裕が無かったんですね。他プロジェクトも並行していたので、もっとか。\nなので実は、「やっぱむり」とギブアップすることも視野に入れながら日々のタスクをこなして行ってました。\nいや自分の限界とタスク量をしっかり検討してから参加表明しろって話ですよね。\nまあ結果として全て期日内に余裕もってこなせたからよかったんですが。\n\n私の場合、曲の構想が降ってくるのって85%くらいは寝付く瞬間なんです。\nおそらくその瞬間が深層意識とリンクしやすいのでしょう、今回私はそれに救われました。\n2月15日の深夜ことでした(チャットログ見返したら分かった)、DETAIL節のイントロ項でも書いていますが、\n恐らく許容範囲内であろう構想が、寝付こうとした瞬間に突然降ってきました。\n「これしかない」と思い慌ててパソコンを立ち上げ0から作り始め作業すること4時間半、無事仕上がりました。\n多分今のところ、音ゲー尺で言えばこの曲が一番早く出来上がった曲です。単純な作業時間的な意味では。\nただこの前にちゃぶ台返しがありますからね。その時からの構想もつぎ込んだおかげかいい曲に仕上がったと思います。\n聞き返すと、実質無意識の私が作り上げたようなもんなのですごく新鮮な感じがして、結構気に入りました。\n音ゲー映えするかは怪しいかもしれませんが、こういう系統も作っていてとても楽しかったので、選択肢の一つに加えたいと思います。\n\n\nここで、ジャケットを担当してくださったしりあさんからお話を頂きましたので\nそちらをインタビューっぽく紹介させていただき結ぼうと思います。",
        storyComment: "Q1. 今回のジャケット制作秘話を教えてください。\nA1. 今回は「曲名」と「各曲に設定されたストーリーのあらすじ」のみでイラストを描くということで、僕にとって初の試みだったのでとても悩みました...。キャラクターはシンデレラをモチーフにし、テーマを「運命から逃れることはできない」と設定して描きました。\n\nQ2. こだわりポイントがあれば是非！\nA2. 物悲しい雰囲気を醸し出すために、色合いや表情、ポーズに気を配り、この物語の「静けさ」を表現しました。イラスト内に枠を描くことで物語の表紙をイメージしましたので、物語についていろいろと想像しながらご覧になってください。楽曲と共に楽しんでいただけたら幸いです！",
        storyEnd: "ありがとうございました！",
      },
      {
        url: "https://soundcloud.com/semicolon0103/yumeiro-no-hanataba",
        src: require("../assets/musics/Yumeiro_no_hanataba.webp"),
        genre: "MUSIC GAME",
        color: "#039BE5",
        title: "夢色の花束",
        text: "花束を渡す感じ",
        date: "2021",
        story: "Yumeiro_no_hanataba",
        artworkBy: "7rika.",
        artworkLink: "https://twitter.com/nanarika73",
        concept: "ストーリー設定をそのまま曲にすべく、乙女心を描写した。\nまた、シンセに疲れたので生音を全面に出す曲を作りたかったから作った。",
        detail: [
          {
            label: "イントロ",
            description: "テーマが乙女心ということでMaiden Nekochanをイメージした進行に。\nモチーフも何回も繰り返しつつも変化を出し、バックでホルンとかを鳴らしそれっぽさを出した。",
          },
          {
            label: "Aメロ(コード)",
            description: "トニックに着地しないことで揺れ動く感情を表現した。\nあまりちょこまかした曲にはしたくなかったので二週繰り返した。",
          },
          {
            label: "Aメロ(旋律)",
            description: "リズミカルで可愛らしい旋律を木管メインで鳴らす。イメージとしてはアニメOPの主旋律。\nこれから何かが始まりそうな期待感を覚えるように意識した。\nまたバックではペット群が静かに鳴る。これはサビの伏線になる。",
          },
          {
            label: "Bメロ",
            description: "なかなか勇気が出ない、揺れ動く心情を描写。\n旋律はAメロをマイナースケールっぽくしたものを基調とし、曲の統一感を出した。\n最後のピッコロのみの部分で一度呼吸を整え、勇気を出してサビに向かうイメージ。",
          },
          {
            label: "サビ",
            description: "サビ頭に分数augはもはや手癖。これにより半音階下降が実現し、少し変則的な進行が作れる。\n上物も、単旋律?ではなくペット群のソリにした。\nAメロで静かになっていたあの軍団が、華々しく旋律群?を奏でる。\nまるで花吹雪の中で想いを伝えてる時みたいな情景。\nDaydreamに続く試みだったが、この手法はコードを自然に全面に出すことができてウマ味かもしれない。",
          },
          {
            label: "アウトロ",
            description: "Aメロにトニックを加えたバージョン。曲の統一感を出すため少し冗長かもしれないが何回か繰り返した。\nというか単純にあの旋律が気に入ったからもう一回使いたかった。\nまた曲の結びにsweepが出てきたので、Skyhigh Nekochanと同じくフィルターでシュっと結んだ。\n出頭のコードをCM7にしておけばよかったなって少し今後悔してたりしてなかったり…難しい",
          },
        ],
        storyMain: "実は初めての外部キャラパケ参加曲だったりします。なんか外部に出たかったから無計画に参加、それも上限の2曲参加です。\nもともと私はゲームBGMを作ってたので、テーマを曲にするのは得意だろと思ったら割とすんなり降ってきました。\n多分私はこういう創作の形が合っているのかもしれません。各位今後ともよろしくお願い致します。(急に改まるな)\n\nこういう、明るい雰囲気だけどただ明るいだけでもないという曲は私としても結構得意とする気がするので\n作っていてとても楽しかったですね。もう自分を全て表現するイメージ。生産者表示みたいな曲になったのではないでしょうか。\nもとの注文書にそこまでの意味が含まれてたかは分からないけど、自分が好きな曲に仕上がったのでヨシ！\n\nでですね、割とクリティカルな裏話が一つあって、それはジャンルです。\n皆さん自分の曲にジャンルを割とすんなり決定出来てる気がするんですが、私の曲って正体不明らしい？んです。\n割と本気でジャンルは\"Nekochan\"で許してほしいってくらい悩むんです。つけてもらっても苦し紛れで、私としても「？」となる始末。\nまず注文書？に曲の目安ジャンルが書いてあったんですが、自分の曲がどれに該当するか分からず。単語も初見だし。\nんで自分の曲の雰囲気に近そうな単語があるジャンルのうち、好きな設定のを選んだんですね。そのうちの一つが本作です。\n雰囲気的にハイスピードだからいいかなってことでそのままローンチ。可愛らしさとハイスピード感を両立できたのではないでしょうか。\n\n\nここで、ジャケットを担当してくださった7rika.さんからお話を頂きましたので\nそちらをインタビューっぽく紹介させていただき結ぼうと思います。",
        storyComment: "Q1. 今回のジャケット制作秘話を教えてください。\nA1. まず楽曲を聴いていない状態で絵を描くということが難しくて、楽曲の雰囲気を壊してしまわないかと不安になりながら恐る恐る描いた記憶がありますw それと同時にどんな楽曲なんだろうって期待に胸を膨らませていました😊\n\nQ2. こだわりポイントがあれば是非！\nA2. スカートに粒子のような輝きを散りばめたこと、かな？個人的には薔薇柄と合うなーと思って入れましたっ",
        storyEnd: "ありがとうございました！",
      },
      {
        url: "https://soundcloud.com/semicolon0103/popping-nekochan",
        src: require("../assets/musics/Popping_Nekochan.webp"),
        genre: "MUSIC GAME",
        color: "#039BE5",
        title: "Popping Nekochan",
        text: "狂詩曲的な",
        date: "2021",
        story: "Popping_Nekochan",
        artworkBy: "いもねぎ",
        artworkLink: "https://twitter.com/imonegi_48",
        concept: "生音100%でマーチングバンドを若干意識した。\nさらに、いかに生音だけで音ゲー曲らしくなるかを模索した。",
        detail: [
          {
            label: "イントロ\nAメロ",
            description: "区切りが分かりにくいし似てるから一括して書く。\n最初は軽い感じで始めて徐々に楽器を増やしていき、転調していき、徐々に賑やかにしていく。\n同じモチーフしか使ってないが、それ以外の構成で深みを出すことを狙った。\n一応は生音で生まれ育ったのでそこら辺の味付けはある程度それっぽいかと。",
          },
          {
            label: "Bメロ",
            description: "tubaを主役にした、少しの暴走パート。\n過去に聞いたそれっぽい雰囲気を形にしたので、そんな変な感じは出てないと思う。\n繋ぎパートは、なんか、そういう感じでしょう。",
          },
          {
            label: "サビ",
            description: "tubaの動きと木管、ピアノたちの暴走、裏打ち跳ねリズムのペット群、\n恐らく生音100%で高BPMで最高潮を表現するならこういう表現になると思う、多分。\nサビ最後の繋ぎ部、Bメロからの繋ぎ部と調が違うだけでほぼ同じ。サブリミナル統一感。",
          },
          {
            label: "アウトロ",
            description: "サビを基に作った、少し抑えめにした余興パート。\n最後の所は実はサビ～アウトロの繋ぎと同じ。\n" + "なので切り貼りして無限にループさせることも可能。".strike() + "\n最後は華麗に締める。指揮者がパっと結ぶイメージ。",
          },
        ],
        storyMain: "念願の生音100%の曲です。Voyager Nekochanの時に作れなかったそのリベンジって感じでしょうか。\nまず例にももれずピアノだけでDominoで打ち込んで曲を作ったんですよ。\nそしたら充てられそうな音色があまりに生音生音していたので「やるしかない」と思ったわけです。\n実はこの頃に合計30kくらいで生音音源を増備していたので、その音源の真価を試したわけです。\n試しに打ち込んだらですね、いやあ思わずそのリアルさに変な声が出てしまって、\nもう何かに取り憑かれたかのように秒でイントロとAメロを作り込みました。\nんで仕上がって通しで聞くと、流石に笑ってしまいました。" + "金の力ってここまで露骨かって。".strike() + "\n\nその後のパートは脳内では仕上がってたんですが、聞いただけで満足してしまってたので作業が止まってしまいました。\nでもいつまでたっても形にしないとアレなので、とんえぼ内で作曲配信して一気に作り上げることを決めました。\nその日のうちに仮版まで何とか仕上がり、生音リベンジは成功したわけです。\nせっかくいい音色になったんだからということで、tubaの動きや楽器の重ね方に関しては凝ろうと思い、\n吟味して何回も作り直したりして、だいぶこだわっているポイントです。\n\nジャケットに関しては、特に周りにいるﾈｺﾁｬﾝ達のネタに気づいて欲しい感があります。私としても(?)\nまず左下でティンパニに突撃してるｱﾋﾙﾁｬﾝはマウリシオ・カーゲル氏作曲のアレです。\nあとは…ここで書いちゃうよりじっくり思い出してもらった方がいいかもしれないので、今はまだ書かないでおきますか…",
        storyComment: "",
        storyEnd: "",
      },   
      {
        url: "https://soundcloud.com/semicolon0103/bravelgent",
        src: require("../assets/musics/Bravelgent.webp"),
        genre: "MUSIC GAME",
        color: "#039BE5",
        title: "Bravelgent",
        text: "襟裳岬イメージ",
        date: "2021",
        story: "Bravelgent",
        artworkBy: "二兎",
        artworkLink: "https://twitter.com/nono_ninjin",
        concept: "キレのいいシンセリードと旋律で透き通ったカッコよさを狙った。\n打楽器隊も歯切れよく音色を調節し、バックで生音を鳴らし調和を目指した。",
        detail: [
          {
            label: "イントロ",
            description: "珍しく旋律先行で作った。跳ねるような爽快感を感じる旋律が降ってきたので、それを形にした。\nしかしクールな感じが欲しかったので短調にし、いろいろやった。",
          },
          {
            label: "Aメロ(コード)",
            description: "徐々に下降、その後トゥーファイブっぽい感じのベタなカッコ良さそうなコードを配置。\n配置する打楽器隊のことを考えたら変なことをすると合わない気がしたのでそのまま配置。",
          },
          {
            label: "Aメロ(旋律)",
            description: "イントロの旋律を転がしていたら裏拍から入るリズミカルなものが降ってきたのでそれを配置。\n何回も繰り返しているが、下手に新な物を配置するとてんやわんやになると思ったため、\n音色を変えたりしたり合いの手を入れるなどしていい塩梅を目指した。",
          },
          {
            label: "Bメロ",
            description: "ここら辺を作る時はAffectationを完全に意識しており、音色構成は割と似ている、と思っている。\n旋律使いまわしもAメロ部で書いてある理由と同一。32分音符だけ短くして旋律の歯切れの良さを意識している。\n繋ぎ部分のペットソリはかなりお気に入り。",
          },
          {
            label: "サビ",
            description: "旋律先行で作り、ファンタジー系RPGの戦闘待機BGMを意識した。打楽器隊のｽｯﾁｬｶ感がそれっぽいと思っている。\nサビ最後の終わらせ方はVIに飛ばして意表を突くことを狙った。転調はするようでしない。\n勢いで作ったのでこれ以上書くことはないが、生音の配置には気を配った。",
          },
          {
            label: "アウトロ",
            description: "サビ最後の旋律を基にいろいろ発展させて曲の統一感を狙った。\nコードの方もシンプルにしたが、三週目で長調っぽくし、五週目はなんか転調してしまった。",
          },
        ],
        storyMain: "私の曲にしては初めてかもしれない、リファレンス曲というものがこの曲には存在します。\nまずここで私の作曲スタンスの一つが(私の閾値では)崩壊するわけですが、\nその曲の一部分をそのまま使ったとかではなく脳内で勝手にミックスされていい感じに出力されたという感じなので\n一般的な価値観ではリファレンス曲ではないのかもしれません。\nなんだか理屈っぽいこと書いてますが、アレです。「曲の構想浮かんだけどこれどっかで聞いたことあるな、あっアレが源流か」という感じです。\nどの曲かというとこちらの曲( https://www.youtube.com/watch?v=Ul-ZPV_9jPw )です。ニコニコ動画の旅動画で知らぬ間に聞いてて気づいたら爽快感=その曲ってチャンク付けされてたのでしょう。\nただ事前情報無しで聞くと気づけないかもしれないですね、ならいいか。\n\n作曲期間に関しては、先述のとおり湧いてきたものを形にしたので、湧いてきてからは秒です。\nしかし湧くまでは焦燥感に駆られてて頭が重かったので珍しく大変でした。時間がかかったとかそういうわけではないんですけど。\nこの時期は一ヵ月に5曲作る必要があったため常に作曲のことに終われ脳内がスタックしてたんです。\nなんせ曲の構想を5曲(うち1曲は後回しにしたので4曲)並行して練るとかいう前代未聞。\n人生で初めて作曲で熱を出してバテて体力的にも大変な時期でした。この副作用でその数か月後間は曲のことを考えたくなくなったり。\n作曲を生業にしているプロの方々の凄まじさをなんとなく理解した気がします。到底及ばない。\n\n肝心の曲の内容に関しては、形にして行ったらAffectationの続編っぽいなって感じで後付けです。\n決して手を抜いたとか妥協したとか言うわけじゃないんですけど、とにかく作らんと随所に迷惑が掛かるのでその危機感がデカかった。\n一連の曲が完成するとミックス確認みたいなものを兼ねてmp3にしてスマホに入れて聞いたりするんですが、\nなんと家で聞いてる時間が無くて、2021年2月の北海道秘境駅巡りで\n21時頃に南富良野町を代行バスで真っ暗闇の中移動しているときに聞いてました。\nそのせいでこの曲を聞き返すとその時の情景が蘇ってきます。\nまぁ楽しかった旅だったのでとてもいいどころか結構嬉しいです。北海道はいいぞ。",
        storyComment: "",
        storyEnd: "",
      },
      {
        url: "https://omoidegyosen.bandcamp.com/album/--2",
        src: require("../assets/musics/Omowide1.webp"),
        genre: "FREE GENRE",
        color: "#FB8C00",
        title: "Eternity Memoria",
        text: "物悲しいピアノ曲",
        date: "2021",
        story: "",
        artworkBy: "",
        artworkLink: "",
        concept: "",
        detail: [
          {
            label: "",
            description: "",
          },
          {
            label: "",
            description: "",
          },
          {
            label: "",
            description: "",
          },
        ],
        storyMain: "",
        storyComment: "",
        storyEnd: "",
      },
      {
        url: "https://d10rama.com/hitoyane/",
        src: require("../assets/musics/Hitoyane.webp"),
        genre: "VISUAL NOVEL",
        color: "#D81B60",
        title: "ひとつ屋根の下なのに",
        text: "わちゃわちゃ学園アニメOP感",
        date: "2021",
        story: "",
        artworkBy: "",
        artworkLink: "",
        concept: "",
        detail: [
          {
            label: "",
            description: "",
          },
          {
            label: "",
            description: "",
          },
          {
            label: "",
            description: "",
          },
        ],
        storyMain: "",
        storyComment: "",
        storyEnd: "",
      },
      {
        url: "https://soundcloud.com/semicolon0103/vermitation",
        src: require("../assets/musics/Vermitation.webp"),
        genre: "MUSIC GAME",
        color: "#039BE5",
        title: "Vermitation",
        text: "厨二っぽく",
        date: "2021",
        story: "Vermitation",
        artworkBy: "いもねぎ",
        artworkLink: "https://twitter.com/imonegi_48",
        concept: "厨二心を炸裂させ、魔女になり切って曲を仕上げた。\n分数aug/augにとどまらず全音音階を採用し、それっぽさを出した。",
        detail: [
          {
            label: "イントロ",
            description: "アコーディオンにチェンバロを加え、グロッケンをまぶしたら\n完全に雰囲気は中世のそれじゃない？ということで露骨にスタート。\nただ音色だけでゴリ押すのは芸が無いし嫌いだし、なんたって全音音階が好きなので使った。\n根音がハッキリしてるとはいえ全音音階で和声的にも怪しくし、そののちに和声的な和音を徐々に加え、\n全音音階の緩急をつけ、いい感じにAメロへという感じにした。",
          },
          {
            label: "Aメロ",
            description: "ヘ短調で始めたがいきなり変ニ短調へ。この忙しなさで気まぐれな魔女感を出した、というのは後付け。\nなぜかShifteneryに脳内ジャックされていたため後半部のリズムはもはやそれであり、\n生産者表示箇所となっている。\nしかしその勢いで、威勢よくトニックで終止してしまったため以降が閃かなくなり、\n信じられないことにこの後2週間強も進捗が生まれなくなる。",
          },
          {
            label: "Bメロ",
            description: "2週間も進捗が皆無となると自らの作曲能力を疑い始める。\nただ作曲に飽きつつも過去曲を聞き、同一曲内パートを使いまわすことを思い出す。\nBメロ後半部ではイントロをアレンジして使うことを決め、\n前半部はその繋ぎとなるパートを即座に作り上げた。\n後半部はペットとピッコロを重ね、荘厳な雰囲気で嵐の前の静けさを表現した。\nその後は堅くドミナントモーションでサビへと続く。",
          },
          {
            label: "サビ",
            description: "変イ短調で始まったと見せかけ嬰ヘ短調へとすり替え。その後はイ短調、ハ短調と転調。\n短調ならピアノ暴走させてもNekochanシリーズにはならんやろ、ということで暴走。\nサックスとクラリネットを重ねた旋律は辻褄合わせ。混フレ用にお使いください。\nところどころ変則的なリズムがあったり大胆な曲の区切りがあるが、\nこれは音ゲー曲を意識した試み。実際に変則的な譜面がついて難しそうになってるので多分正解。\nそのまま、自分の中で確立している旋律のアルゴリズムは変えず、\nそのままテンポを落とすことなくOperonらしく堂々と終止。\nアウトロなんてものはない。今作の場合、無理に考えたら蛇足になると思う。",
          },
        ],
        storyMain: "もうとっくに厨二とかいう年じゃないハズなんですけど、なんかそういうお年頃なんでしょうか。\nそういう曲が作りたかったので作りました。\n全音音階にハマっていて、魔女っぽい雰囲気に抜擢だと思い、思いっきり使いました。\nただ我々は西洋音楽に縛られてるので、いずれは\"元\"に戻りたくなるんですよ。\nそういった塩梅は一昨年から模索していて、自分なりの最適解が見つかりそれを使ったのが今作だったりします。割と自信ポイントです。\n\nそれよりも今作で特筆すべきは作曲放棄期間でしょう。\n2週間も何も降ってこないなんて前代未聞。DETAIL節にも書きましたが、やっぱ原点に立ち返ることって大切です。\n同一曲内パートを使いまわすことって、発想力の負けなんですよ。だから嫌だった。\nでもただ使いまわすんじゃなくて、アレンジとかすればいい感じで統一感が出るっぽい事を知ったんです。\nちょこまかした曲を作ってましたが、今作は一種のターニングポイントになるのではないでしょうか。\nまた、苦しんだなりに通しで聞いてみると上手く様々な展開を使えてるなと我ながら冷静に思いました。\n音価を上手く制御してBPMを一切変えることなく緩急をつける辺りも、しっかりできているのではと。\n\n実はここまで書いた以上に苦労した点があります。\nそれは、本当に呪われたかのようにプロジェクトファイルが突然壊れてしまい復元ポイントから作り直した点です。\n作業をしようと開くと、再生される音程が変わってたんですね。初めて遭遇したらトラウマになりそうですが、\nオーディオインターフェースのサンプリングレートを変更するとよくあることなので、そこは普通に直したんですね。\nしたら今度は小節線が不規則にズレるんですよ。これは初めてでした。猫の知能では全くもって理解できない現象でした。\nいろいろトラブルシュートしましたが、埒が明かなくなったんです。\n「魔女になって曲を作っていたら、プロジェクトファイルに呪いが掛かってしまい復元ポイントから作り直した話(実話)」\n恐らく入出力のサンプリングレートをなんかのタイミングで変更したのが原因でしょうが、\n同時期に並行していた他プロジェクトファイルにも影響が波及。とんだ災難でした。\nとりあえず最低でも48kHz以上の音質に全世界統一して欲しいです。\n44.1kHzなんて汚い音聞いていられません。ヤードポンド法と共に今すぐ無くせ\nちなみに冗談でもなく道端の猫除けの音がうるさいので、私は本当に猫なのかもしれません。\n\nジャケットに関してはよく話し合ったと思います。楽しかった。\n元はというと、いくつかの曲のラフを準備し、それをジャケ担当のいもねぎに聞かせて\nどれを本採用するかということで選ばれたのがこの曲となります。\nいつも曲を元に描いてもらっているので、描く側にも選択の余地があった方が良いだろうと思ったので。\nまず曲名から基調となる色を紅に決め、火属性の魔法使いっぽい雰囲気がいいよねということになりました。\n魔女っぽい服を着て、先から炎が出る杖をカッコよく持ち、右手では焼鳥のおばけを召喚。\nちなみにこのおばけは、焼鳥にされたけどおばけになったので火が怖くなくなったという裏設定があると、いもねぎ談。\n他にも、炎の根本辺りに飛んでいる羽を生やしたコウモリみたいなあひるや、月の近くに飛んでる謎の飛行物体等…\n気づく人なら絶対クスっとなると思うのでよく見てもらえると私も嬉しいです。\n\n当初はハロウィン感は全く意識して無かったんですが、雰囲気からかハロウィンコンセプトと思われてしまいました。\n別に不本意でもないんですが、とりあえずハロウィンを完全に理解した。\n私自身かなり気に入ったので、マインクラフトのスキンもこの子を基に作ってもらったりして。",
        storyComment: "",
        storyEnd: "",
      },
      {
        url: "https://soundcloud.com/semicolon0103/voyager-nekochan",
        src: require("../assets/musics/Voyager_Nekochan.webp"),
        genre: "MUSIC GAME",
        color: "#039BE5",
        title: "Voyager Nekochan",
        text: "宇宙感あるエンディング",
        date: "2020",
        story: "Voyager_Nekochan",
        artworkBy: "いもねぎ",
        artworkLink: "https://twitter.com/imonegi_48",
        concept: "冒険に出る高揚感と躍動感、旅路を振り返る寂寥感、\nそしてこれからに対する期待感と不安感、\nそのすべてを詰め込んだAsteroid Nekochanの続編。",
        detail: [
          {
            label: "イントロ",
            description: "短三度ずつ徐々に上げて行き高揚感を出す。多分ここで使う間隔はこれが最適解。\nピアノで華麗にアルペジオを決めてからシンセリードで広大な宇宙を表現。\nその後は再びピアノの登場。変則的なリズムを挟み、9thを下方変位させ泣きっぽくさせAメロへ繋ぐ。",
          },
          {
            label: "Aメロ",
            description: "ここは非常に珍しくベース先行で作った。その後、順調な旅路を表現する旋律を作り、\n歯切れのよいスネアをはじめとする打楽器隊を配置。\n私の専売特許的なリズムで準固有和音地帯をはさみお口直し、二週目を開始、トニックでAメロを区切る。",
          },
          {
            label: "Bメロ",
            description: "半音下降クリシェで旅路を振り返る。\nゆったりとしたところは生音が合うと思い、生音を意識した。\n前半に比べ後半は今までの長い道のりを振り返る感じの雰囲気に。\n変イ短調だと思うのにAが出てくるのが自分でも分かってない。\nここら辺の管楽器四重奏は各声部の動きを意識して配置した。",
          },
          {
            label: "サビ",
            description: "I→Iaug→IV→IVmの動きが好き。\nサビはこの進行をもとに辻褄合わせたと言っても過言じゃないかもしれない。\nBメロからソプラノ的立ち位置をしていた木管軍団をそのまま旋律に充て\nその下で静かにペットを鳴らす。\nバックではNekochanシリーズらしくピアノを暴走。\n実はこの暴走、Skyhigh Nekochanとほぼ同一なんです。よく聞いてみてください。\n2週目ではAメロで旋律を奏でたシンセリードも仲間入り。\n期待と不安が入り混じるもぼくらは先に進む、そんな感じを出した。",
          },
          {
            label: "アウトロ",
            description: "テンポを落とし、チェレスタのキラリンでゆっくりと締める。\nアウトロ出だしのFXkickが衝撃音みたいに聞こえるから、\nこの時に宇宙船が小惑星にぶつかりその後のチェレスタの旋律が鎮魂歌っぽく聞こえるなと\n私の中で若干後悔しているけど、でも代案が閃かないのでこれが正解ということで。",
          },
        ],
        storyMain: "元々はオケ曲だったんですよ。私は曲を作る時、あらかじめDominoでピアノのみで下書きをするんです。\nそこにシンセの音を充てて今までの曲は作られてきたわけですが、今回ばかりはどうも生音しかピンと来ない。\n実際に、イントロだけではありますがオケ曲として作ったんです。\nが、当時持ってた音源ではあんまりにチープすぎて嫌気が差したのでやむなくシンセ化。\n\nいろいろプリセットを漁って弄ったりして、それっぽい音色を探すんですが、\nポンポンと湧いてくる構想が渋滞している中、それらを忘れずに、\nかといって形にできないまま音色を探すって本当につまらなくて苦痛、苦行そのものなんです。\n作曲が最近つまらなくなってるんですが大きな原因はこれです。なんとかならんか。\n私がシンセを使いたくない理由はここにもあって、\nなぜなら一方生音ならある程度定石があるのでそれに則って音を割り当てるだけの作業なので\nただ\"曲として何かを作るだけ\"ってのならそっちが遥かに簡単なわけです。\nみんなマジどうやってシンセ曲作ってるわけ。楽器法みたいなもんでもあるわけ。あたしゃ知らんのやが。\n何も知らないので私は個人的に刺さった曲をたくさん聞いてそこから帰納的に最適解を導くようにしてますが(導けてんのか？)、\nもっといい方法あるでしょ本当は。人力深層学習じゃあないんだよ\n聞き返すと自分が好きと思える曲に仕上がってるので人力深層学習は出来ているんじゃないでしょうか知らんけど。\n\n閑話休題、イントロを試しに見つかった音色で、しっかり打楽器隊まで組んでみたら\nなんということでしょう、想像以上に高揚感を煽る、「もうこれしかない！」と思える草案が仕上がったではありませんか。\nその後のリズムもなんかよく分からん天才的な閃きで個人的に気に入って、大波が来ましたね。\nAメロでピアノをゆったりとアルペジオさせてるんですが、当初は「マンネリ化してて嫌」と思って不採用の方向でした。\nイントロからのアルペジオが続いてて変化が少ないと当時の私は思ったのでしょう。\nただ自分の過去曲を聞いても該当部が無く、ただ脳内に長年存在していただけの未公表案ということで思い切って採用へ。\n通しで聞いたら「天才」って言いながらその後は秒で作りました。サビのﾀｶﾀｶﾀｰｰﾝってリズムもなんか降ってきました。\nこう考えてみると作曲って深層意識から何か急に湧いてきたものを形にしている時が一番楽しいですね、私は。\n\nジャケットに関しては、多分この時点までの曲で一番いもねぎとすり合わせした気がします。\nこの宇宙船の名前はｱﾋﾙﾁｬﾝ号。構造的に深海に潜ってそう。(？)\nパステルカラーのﾈｺﾁｬﾝ達の色は、もとは仮塗り段階？だったらしいんですが\n私が気に入ってしまったためそのまま色を本採用。\nそろそろｱﾋﾙﾁｬﾝにもジャケット入りしてもらおうということで右の羽にはｱﾋﾙﾁｬﾝの姿が。\nちなみに宇宙船の中にいる子はいつもの子。\nやっぱりゼログラは軽くて実生活でも掛けやすくていいです(企業案件じゃないです)(なんの話してるんだ)\n宇宙船の操作盤、ここに載せてるのはKSM版ですが、某コントローラになってます。BMS版( http://manbow.nothing.sh/event/event.cgi?action=More_def&num=276&event=133 )だとコントローラが…",
        storyComment: "",
        storyEnd: "",
      },
      {
        url: "https://soundcloud.com/semicolon0103/daydream",
        src: require("../assets/musics/Daydream.webp"),
        genre: "MUSIC GAME",
        color: "#039BE5",
        title: "Daydream",
        text: "夢うつつ",
        date: "2020",
        story: "Daydream",
        artworkBy: "堀江(東北大学学友会写真部)",
        artworkLink: "",
        concept: "夢うつつを曲にした。\nまた分数aug/augを効果的に用い、浮遊感を狙った。",
        detail: [
          {
            label: "イントロ",
            description: "リズミカルなピアノが降ってきたのでそれを基に作り上げた。\n一方打楽器隊はリゾート気分で作り上げた。\n思い返すとイントロの最後の方はMelancholyそっくりだなぁと思ったけどとりあえずよし。",
          },
          {
            label: "Aメロ",
            description: "コード先行で作った。夢うつつ、浮遊感は分数augしかないだろうということで\nふんだんに使いつつも違和感がない旋律を充てて二週繰り返し統一感を出した。\n白昼夢って曲なのでそんなに活発にしてもしょうがないのでのんびりと仕上げた",
          },
          {
            label: "Bメロ",
            description: "半音下降クリシェ。ただ分数augを使いたかっただけ。\n旋律はのんびりしながらそれっぽいのを付けた。\nまたここら辺でもAsteroid Nekochanで使い始めたIIm→VM7の後にVm7を持ってくるヤツをやってる。\nサビに向かう直前は曲の始めから一生鳴ってるリズミカルな打楽器隊を復活させた。\nサビ旋律はいいのが思いつかなかったのでホルンのソリにすると決めたので、それの繋ぎで終えた。",
          },
          {
            label: "サビ",
            description: "実はピアノを先に雰囲気で組んでから後の音色を充てた。\nホルンの音色はとても好きなので、それを聞かせる曲に仕上げた。\nホルンにあまり音を細かく刻ませたくない性格もあって、\nのんびりとした長い音価でゆったりとした盛り上がりを実現した。\n一番気に入っているのはホルンでCmを鳴らすところ。ここだけでご飯2杯は行ける。",
          },
          {
            label: "アウトロ",
            description: "ゆったりと締める。よく考えてないけどここにはこういうコード進行が合うはず。\nチェレスタも目立ちすぎないように8分で鳴らし、\nバックではピアノでいろいろ付加した和音を慣らして曲に深みを持たせた。\n敢えてドミナントで半終止させたまま終わらせ、\nリバースシンバルの余韻とウィンドチャイムでボヤボヤした白昼夢を描写。",
          },
        ],
        storyMain: "実はこの曲は存在しない計画でした。というのも、とんえぼパッケ作る時あらかじめ作る曲のBPMをおおよその値で指定しておくんですよ。\nそこに130の数値はありませんでした。なぜなら暴力的なBPM230位のボス曲を書くつもりだったので。\nしかし、エアコンの効いてる室内ででろ～んと日向ぼっこしてたらこの曲の構想が降ってきたので\n慌てて勢いで曲にしました。作曲時間も正味数時間なんじゃないでしょうか。\n結果的にボス枠はらふむが担当してくれることになったので結果オーライかな？って感じです。\nまた今まで自分の曲にこういったゆったり100%の曲は存在しなかったので新規路線開拓でもあります。\n作曲頻度が高いと過去曲と類似する悩みがあるため、\n正直いろいろな作風を作れたいので将来の布石ということで。\n\nジャケットに関しては、これは早速写真部さんの作品です。\n具体的なプロシージャはわざわざ書きませんが、曲のサンプルとイメージ、背景をお伝えしたら\n曲そのものみたいなジャケットが仕上がりました。\n初めての野心的な試みだったんですが想像以上にいいものになって、言い出しっぺ・連絡口の私としても本当に感謝でした。\nこの時期はコロナ鍋で学祭が実質中止、われわれとんえぼとしても写真部さんとしても展示の場を失ったわけで、\nその中でもこうして作品として外部に出せるというのはお互いにとっていいものなのかなって思ってます。\nこれからもどうぞよろしくお願いします。",
        storyComment: "",
        storyEnd: "",
      },
      {
        url: "https://soundcloud.com/semicolon0103/skyhigh-nekochan",
        src: require("../assets/musics/Skyhigh_Nekochan.webp"),
        genre: "MUSIC GAME",
        color: "#039BE5",
        title: "Skyhigh Nekochan",
        text: "ただ楽しそうな感じ",
        date: "2020",
        story: "Skyhigh_Nekochan",
        artworkBy: "umr",
        artworkLink: "https://twitter.com/BlazeConductor",
        concept: "空飛ぶﾈｺﾁｬﾝ、疾走感any%\nBayside Nekochanみたいに「楽しさ100%とにかく空高く駆け抜けろ！」という\nNekochanシリーズの権化のような曲に仕上げた。",
        detail: [
          {
            label: "イントロ(コード)",
            description: "元はというとDTM講習会の指導で使う予定の進行だった。\n「晴れ渡る空を駆け抜ける爽快な曲を作りたい」といわれたので\nそういうコードをG majorで作り準備しておいたけど結局自分が使うことに。ラッキー。\n作曲が初めての人に使う予定の進行だったため変な小細工はしていない。",
          },
          {
            label: "イントロ(旋律)",
            description: "コードを頭の中で転がしていたら降ってきたピアノの暴走を\nNekochanシリーズらしくそのまま置いた。",
          },
          {
            label: "Aメロ",
            description: "手癖で作ったが、思い返すとMaiden Nekochanと調まで同一なことに今気づいた。\nただ半音で下がる進行がこの頃アツかったので、それを組み込んだ。\n二週繰り返すが、疾走感を全面に出すためシンプルなものにした。\n旋律に関してもコードに合うように辻褄を合わせただけ。\n一週目は旋律を聞かせ、二週目はピアノ暴走を聞かせるイメージ。",
          },
          {
            label: "Bメロ",
            description: "一旦休止させるイメージ。まるで飛行機の窓から夕暮れが見えるイメージ。\nすなわち活動的なコードをここに配置するのは誤りなので、\nIIIm→IVを往復するのを基本にして構築した。\n最初は音価を長くしリズム隊を鎮静化させ、後半部はサビに続くため徐々に活発にし、\n曲の自然な展開と緩急を意識した。",
          },
          {
            label: "サビ",
            description: "さんざん使いまわされてる進行に分数augを組み込んだ進行にし、\n旋律はAメロと同じものにし曲の統一感を意識した。\n同一旋律でもコードを変えると、統一感が出せて意外と良いのかもしれない。\n同一パートを二週繰り返すが、今までの部分と同様、\n前半と後半で旋律とピアノ暴走をそれぞれ聞かせた。\nそのまま突っ走っていきジャーンと終了。アウトロなんてものはない。\nフィルターを掛けてシュっと終わらせるのが最近気に入っている。",
          },
        ],
        storyMain: "この時、というかこの年の春のパッケージの時に作曲人員の不足が顕在化してたんです。とんえぼ創作班の裏話になっちゃうんですけど。\n当時とりまとめしてた某氏が「今パッケージ(2020春パッケ)が作れたのは幸運だった」とか言ってたんですよ。\nただ自分自身、このとんえぼ創作班に創作活動という面で本当に支えられて今があるので、\n恩返しがしたい的な感じで何かしたいなと思ったわけです。\n作曲力、質は分からんけど曲数を錬成したり指導するのだけは以前から自信あったので、\n思い立ったが吉日、今ここで自分が講習会的なことをしないと創作班は人員不足で潰れると確信したので講習会をやったんです。\n口先だけでなく行動で示せ。\n\n参加希望者を募ったら6人が釣れたんです。\nおおよそ想像通りの人数だったんで、こちらで準備してた作曲経験者の直下に彼らを配置し\nマンツーマン指導を各々したんです。言い出しっぺということもあり人数的に私だけは2人を受け持ったんですが、\n定期的に全員の進捗を確認して状況把握して適宜助け舟を出したり。\nDiscordの画面共有でお互い都合のいい時間に指導したんですね。\n事前の綿密な調査と立案、念入りなサポートの甲斐あってか、\nなんと全員が自立してくれたんですね。みんな本当に頑張ったと思います。\nとんえぼパッケージを追ってくださっている方なら分かると思うんですが、\nこの学祭パッケージに何人もNewComerたちがいると思いますが、それはこの講習会で初めて曲を作った子たちです。\n一部のNewComerたちは最初から強者だったので、その子たちには自由気ままに作曲させた、と直上曰く。\nとりあえず各々の作曲意欲に火がついてくれて本当によかったです。\n\nああ、完全にとんえぼ創作班の裏話になってましたね。この曲はその過程で生まれたんですよ。\nDETAIL節にも書いたんですが、もともとイントロで使った進行は指導で使い、\nこの進行をもとに旋律を組んで一曲を作る予定だったんですが、\n受け持ってた1人目の子が「メロディ閃いたんでこれを基に一曲作りたいんです」と言ってきて。\nそれは良い意味で想定外で、なら準備してた進行は自分の曲に使おうということで生まれたのがこの曲です。\nせっかくなら、楽しさ100%の繋がりでBayside Nekochanの続編的な曲を目指そうとしたんです。\nんで気づいたら出来上がってました。この時は自分の曲より講習会参加者の曲のことを考えていたので、\n己の曲に関してはそれほど何も考えていませんでした。曲は気づいたらなんか出来上がってるもの。\n\nちなみに講習会ですが、一回でやめようとしたら嬉しいことに随所から好評と二回目開催希望の声を多く頂いちゃったので\n就活が心配だったんですが別にいいかってことで、ご要望にお応えということで二回目の講習会も開催しました。\n時系列的にはこの曲の半年後ですが、合計10人くらいの人が結果として創作班に加わってくれました。本当にありがとう。\n去年の同じ頃には存続の危機とかだったのに、いまや内部曲が多くて譜面精査が大変という嬉しい悲鳴状態。\nジャケットは私のツテで学友会写真部さんなどに協力いただけ、新たなサークル間交流が生まれたのはいいけど譜面はどうしても自前。\n譜面難易度精査は我々のパッケージで大切にしていることの一つなのでそれをしないのは嫌だし、\n負担をどうしようかと頭を悩ましていたりします。\n我々部員個々人のツテで提供してくださる外部曲も、本当は収録したいので。\nいつかホンマに30曲収録行くんちゃうか、いや軽く数えたら行きました。\n以上、我々が表向きでは何気な～く出しているパッケージ制作秘話の一部でした。あれ、Skyhigh Nekochanの話はいずこへ…？\nこれからもとんえぼパッケージをどうぞよろしくお願いいたします。",
        storyComment: "",
        storyEnd: "",
      }, 
      {
        url: "https://soundcloud.com/semicolon0103/shiftenery-ksm-edit",
        src: require("../assets/musics/Shiftenery.webp"),
        genre: "MUSIC GAME",
        color: "#039BE5",
        title: "Shiftenery",
        text: "2日で急遽作ることに",
        date: "2020",
        story: "Shiftenery",
        artworkBy: "二兎",
        artworkLink: "https://twitter.com/nono_ninjin",
        concept: "初めての外部イベントに出す曲ということで構成を特に丁寧に作った。\nとはいってもイベントの存在を知ってから完成まで7日しかなく\nBMS化の音切りを含めないと5日で最終版まで作った作曲RTA状態の曲だったりする。",
        detail: [
          {
            label: "イントロ(コード)",
            description: "カノン進行っぽい動きを二つ準備し、その間を試したかった増五度転調で繋ぐ。\nインプレを見るに違和感を持ったわずかな人は恐らくここが引っ掛かったと推察するが\nそんなの知ったことではない。私の曲なので。\n中心軸システムとかそこらへん見てくるといいんじゃないかな知らんけど",
          },
          {
            label: "イントロ(旋律)",
            description: "旋律は、順次下降していくコードと相反するように上昇するように組んだ。\nこうすることで徐々に広がりを見せる演出を狙った。\n16分のピロピロが始まる辺りはあくまでAメロへのつなぎなので\n深い意味はない。",
          },
          {
            label: "Aメロ(コード)",
            description: "実はここはドリア旋法っぽい感じを狙っていたりする。\nそれにより勇ましい雰囲気を作り、堅実に曲を始めるという意図をここで示した。\nというのは後付けで、ここは実は旋律先行。\nVI7からの流れでA minorから属調のE minorへ転調。お手軽転調。",
          },
          {
            label: "Aメロ(旋律)",
            description: "なんかリズミカルな旋律が降ってきたのでそれをピアノで鳴らし、\n降ってこなかった場所は合いの手になるようなリードメロを\n和音に合うように辻褄を合わせて作った。",
          },
          {
            label: "Bメロ",
            description: "先ほどと同じような転調をしてあたかもB minorに行くように見せて思いっきりD minor(ドリア)へ。\nこの部分は閃かなかったので、Highspeed Nekochanをそのまま持ってきた。\nただそのままだと芸がないので付点を付けたリズムにした。\nじゃあここからHighspeed Nekochanに曲をすり替える、てのは流石に問題なので、\nいい感じに鎮静化させてBメロをドミナントで半終止させ、区切りながらも曲がまだ続くことを明示。",
          },
          {
            label: "再現部(兼サビ)",
            description: "イントロを転調させて発展させまくった部分。\nイントロパートのひらめきが個人的にキていたので丁寧に増強して使いまわしをしたかった。\nインプレでゴシックと言われたが私自身全く自覚はなく、\nおそらくここらへんの旋律の流れが旋律的短音階になってるからかとなんとなく予想はつくけど\nとりあえず私の手癖はゴシック系統なんだということはよくわかった。\nクラシック時代の呪縛はいまだに解けない。",
          },
          {
            label: "アウトロ",
            description: "さんざん転調したので最後くらいは落ち着こうとシンプルな進行にした。\nここら辺でリード群とピアノを、ピロピロと旋律で持ち替えさせるのが個人的にミソ。\n終わりに向けてさらに盛り上がりを見せ、意表を突くリズムでパスっと終止。\n指揮者が指揮棒を明後日の方向に向けながら数秒固まってる様子が目に浮かぶ、そんな感じ。",
          },
        ],
        storyMain: "実質的に".strike() + "初めて外部に向けた曲を書きました。白状しますが、明言こそしませんがこの電子音楽の世界も所詮は知名度なんだなって悟り、\n自分なりには割と手応えがあるのにいつまで経っても見向きされないのが癪だったため、\n「わたしはここにいるぞ」じゃないですがそんな感じで存在感をアピールしたくて外部のイベントが無いかなと思った矢先の無名戦でした。\nというか外部イベントに出てない存在を認知するほうが難しいですよね。とんえぼのパッケージ追ってくださって、\n譜面だけでなく曲の方まで気にかけて下さってる方じゃないと。そうでないとクローラでもなきゃ認知できないし、\n当時の状態は当然の結果ではと、冷静になった今はそう回顧します。\n\n私は作曲を始めた当初は周囲からひどい目に遭ってたせいか自己肯定感がほぼ皆無なのもあって\n自分の作品を大体的に告知するという行為が、なんか誇示してるみたいで恥ずかしくて仕方ないと感じるんですよね。\n後遺症なのかそれは今でも少しばかり。\nそれにだって、私が曲作る行為ってそんなに偉いことなんですか？宣伝するようなことなんですか？出来て当たり前じゃないですか。\n私は曲が作れて当然で作れないことは寧ろおかしいことなんです。あ、ほかの人に対しては全くそう思ってません。もちろん当然です。\nなので作品登録時と最終日くらいにしか流さなかった記憶があります。\nそれでも多くの方に遊んでいただき、大半の方にお褒めいただいて本当に光栄でした。\n\nなんだかよーわからん嫌がらせをしてきたりいちゃもん付けるという、\n(あくまで)私の常識では到底理解が及ばない人間が確かに存在していることも再認識しましたが、\nそんなより自分のことを正当に評価してくださる方々がしっかりいらっしゃることを知り、\n少しばかりか創作面での心の戸を開いた、という、個人的にターニングポイントとなる曲が本作品だったりします。\n作曲中は生ハムとビールとカフェオレを食しながらひたすら「おいしい(こなみ)」ゆーて脳を溶かしそのまま勢いで書いてたんですが、\nどちらかというと背景がすごい深いんだなって、回顧した時にビビりました。自分の曲なのに。\n\nジャケットに関して裏話があります。吟世かいな曰くこれはアー写らしいですね。\nそれはさておき私の眼鏡の右目側の玉にﾈｺﾁｬﾝがこっそり描きこまれていたりします。よく見てみてください。\n配色の方も、紅から碧へ色が変わっていくような曲の雰囲気を背景に描写したと二兎曰く。\nあまりに短い納期にもかかわらずバシッと合うジャケットを描いて下さった氏には\n感謝だけでなく申し訳なさもあります。思い付きで出るもんじゃないですね。\n\n当時がきっかけの繋がりは非常に密どころか私にとってかけがえのないものであり、\nOperonの時同様、本当に各位には感謝しかありません。",
        storyComment: "",
        storyEnd: "",
      }, 
      {
        url: "https://soundcloud.com/semicolon0103/cuddle-nekochan",
        src: require("../assets/musics/Cuddle_Nekochan.webp"),
        genre: "MUSIC GAME",
        color: "#039BE5",
        title: "Cuddle Nekochan",
        text: "癒しを求めて",
        date: "2020",
        story: "Cuddle_Nekochan",
        artworkBy: "いもねぎ",
        artworkLink: "https://twitter.com/imonegi_48",
        concept: "Cubaseリハビリ曲その2。マキシマイザの音圧ぶち上げ機能に感覚と鼓膜が麻痺して大変だった。\nまた分数augからサビを始める曲を作りたかったので、作った。\n実は情景描写曲でもあり、卒業研究で心身を崩壊していた私を癒してくれる存在を曲にした。",
        detail: [
          {
            label: "イントロ",
            description: "脳裏をよぎったBayside Nekochan。あの時の楽しさを思い出しつつ半音で動くベースを作ったら旋律と上手く噛み合わなくなり泣きアニメ。",
          },
          {
            label: "Aメロ(コード)",
            description: "よくよく聞き返すとMaiden NekochanのAメロと進行が同じかもしれない。\n勢いに任せて作ると自分の過去曲と類似することが良くある。",
          },
          {
            label: "Aメロ(旋律)",
            description: "旋律と言っていいか分からないけどNekochanシリーズらしくピアノを暴走させ、\n一応2種のリードで掛け合わせをさせた。当時はその掛け合わせをNekochanシリーズとしていたが\nどうやら一般的にはゴチャゴチャして聞きにくいということで以降これはやめた。",
          },
          {
            label: "Bメロ",
            description: "掛け合わせの旋律を上手く崩していきながら下降進行。\nまたAsteroid Nekochanの時と同じくIIm→VM7の後にVm7を持って来たかったので持ってきた。\nなかなか答えに行きつけない、もやもやした感じをそのまま曲にした。",
          },
          {
            label: "サビ",
            description: "こう、心に強く訴えかけしてくる雰囲気というか、辛さに耐えてた何かが堰を切ったように溶けていく？様子を曲にした。\nまたコードも出だしに分数augを置いてスタート。こういう曲は割とまだ少ないのでは。\nそろそろ音ゲー曲っぽい風にしたかったので、中盤で特有のリズムで四つ打ちキャンセルをし、それっぽさを目指した。\n一旦静かになりピアノと2種リードのソリに繋がり、アウトロへ。",
          },
          {
            label: "アウトロ",
            description: "意外と同一部分を何回もしつこいように繰り返しても許されるっぽい事を知ったので、\n何も考えずに尺稼ぎ。コストカット。\n最後はリタルダンドしながらピアノで綺麗に決めて結ぶ。",
          },
        ],
        storyMain: "こっちは割といろいろ曲のことを考えながら作りました。\nオモゐデ漁船 アドベントカレンダー( https://note.com/semicolon0103/n/na5f69a8bf619 )で書いた旅行記の旅程を立てながら作ってたんですよね。\nというのも…\n\n当時は実験が好きで、そんな感じできっと研究も楽しいものだと思ってたんですが、\n蓋を開けてみたらただの体力勝負という現実で心が折れ、\n後になって気づいたんですがパワハラ(ボスとかにではない)と言えるような仕打ちを受けたもんですから限界に達したんです。\n食も通らなくなり動けなくなり、あぁ楽に自死するなら餓死かなぁと自らで人体実験したら本当に起きれなくなって。\nもし今ここで死んだら特殊清掃代とか進行中のプロジェクトに迷惑かけるし一旦身元整理せな、\nと文字通り死ぬ気で起きて一命をとりとめる、そういう心身の状況でした。\nもうだから、研究室の闇に飲み込まれていく後輩たちがどんどん壊れていく様を見ると本当にいたたまれません。\nなーにが学生の心身の健康をどうこうだ、って当事者並感。寝言は寝て言え\n卒業時のアンケートに思いの丈全てぶちまけたんですがあれは反映されたのでしょうか。まぁいいや\n\nあーいう地獄って、時間が解決してくれるんですね。研究室のボスたちが気を効かせてくれて何とか致命傷で済み、\nようやく解放の見通しが立った、という瞬間にはExcelとYahoo乗換案内を開いて旅程を立てていました。\nこのサイトにTRIPってページがある通り、私は旅がすごい好きなんです。この時は幸せでした。\nいまだにこの曲を作った時の心理状態を上手く言語化できないんですけど、\n地獄からの開放感に加え、ズタボロの私を癒してくれる存在にズブズブ依存するじゃないですけど、\nまぁ多分そんな感じのサムシング。きっと多分通じる。\n\n曲の方はというと、結構想いを込めたのに対し反響はイマイチで、\nというのも恐らくイントロ部の旋律が刺さらなかったのかなぁという自覚はあります。\nああこういうのはウケが悪いんだなってなりました。人間の心理って案外単純なもんです。\n\nジャケットに関しても裏話があります。抱きかかえられてる黒猫の目は、京都のたまゆらんさんで会った猫ちゃんがモデルです。\nまたあひるのクッションは説明不要でしょう。\nその右下のハート形クッションには難易度差分として難易度の文字を入れる予定でしたがそれはリストラ。\nメガネも私が掛けてるものがモデルだったり、そもそも中央の子は私がモデルだったり。白衣は私が生物・化学系だからとか、そんな感じです。\nおや、スマホの画面、なんだか見覚えのある画像が…",
        storyComment: "",
        storyEnd: "",
      },    
      {
        url: "https://soundcloud.com/semicolon0103/affectation",
        src: require("../assets/musics/Affectation.webp"),
        genre: "MUSIC GAME",
        color: "#039BE5",
        title: "Affectation",
        text: "カッコよくつくった",
        date: "2020",
        story: "Affectation",
        artworkBy: "ラマ助",
        artworkLink: "",
        concept: "作曲環境をDominoからCubaseに移行するという節目の曲。\n使える音の幅が無限大に広がったため、音色選択で迷子になり大変だった。\nまた節目ということで、高2の時に降ってきた旋律を上手く使い、復刻となる曲を目指した。",
        detail: [
          {
            label: "イントロ",
            description: "とりあえずよくわからなかったのでそれっぽい旋律をそれっぽいシンセリードで鳴らした\nせっかく数万で買った有料DAWを無駄にしたくなく操作を覚えるので精いっぱいだったので何も考えられてない。",
          },
          {
            label: "Aメロ(コード)",
            description: "先述の通り何も考えられなかったのでとりあえず一曲作り上げることを目指すべくイントロと同一にして旋律の方で差別化を図ることを考えた。",
          },
          {
            label: "Aメロ(旋律)",
            description: "副旋律なのか主旋律なのか分からないがとりあえず私のアイデンティティであるピアノでいろいろ鳴らした。",
          },
          {
            label: "Bメロ",
            description: "イントロから鳴ってる旋律を基に徐々に崩していくことで曲の統一感を目指した。\nコード進行もちょっと凝ったものを考える余裕が出てきた。\nまたずっと四つ打ちで鳴らしpad部を鳴らさないというのは個人的に斬新で、作っていて新鮮だった。\nそこからなぜ閃いたのかよくわからない部分をはさみ分数augを経てサビへ",
          },
          {
            label: "サビ",
            description: "高2の頃に降ってきた旋律・コード進行をそのまま利用。個人的にアツい場所。\n高校時代は属七くらいしかエモい和音は知らなかったので非常にシンプルになっている。",
          },
          {
            label: "大サビ",
            description: "サビの盛り上がりを受けて今度はピアノのリズミカルなパートへ。\nここは私にしては珍しくピアノ旋律先行で作った。\n高校時代のサビと違いこちらにはdimが入っている。\n後半部分がチーターマンっぽい空耳に聞こえて個人的に悩んでいる。",
          },
          {
            label: "アウトロ",
            description: "大サビの流れを汲み、徐々に盛り上がらせてOperonらしく終止。\n11thまで鳴ってるが意外と違和感はないと思っている。",
          },
        ],
        storyMain: "DominoにReaperという無料環境で作っていたんですが、この曲が実質的な有料DAW曲一曲目です。" + "実質と書いてるのには訳があって".strike() + "\nそもそも作曲ソフトにお金を当時は掛けたくなかったんですよ。だって課金していい音色使えれば良い曲になるのは自明なので。\nそうして作られた曲ってオリジナリティあるの？課金したソフトのお陰では？と斜に構えていた頃があったんですが、\n「課金すればもっと君の曲は化ける」ととある方にそそのかされ仰ってもらい、触ってみようとしたわけです。\n\nどのソフトが良いか分からなかったんですが、とりあえずマイコンプロシージャで利用者が多いCubaseにしました。\n実は買ったのはこれの一年前で、使わずずっと寝かせていたんです。\nだって7年間も使っていた環境があまりに快適だったから。Dominoって言うんですけど。\nCubaseを使っている今でも、正直に言えばDominoの操作性や起動速度は神です。まぁDAWとmidiシーケンサ？を比較するなという話ですが。\n\nなんか作曲環境のことしか言ってませんね。実際そうで、高2の時の構想を曲に仕上げたいというモチベ以外は、有料ソフトに慣れたかっただけなので。\nただ個人的にも結構カッコ良さげな曲に仕上がってる自信があり、どうやら大サビのピアノの旋律が割と好評だったそうです。\nみんなの好みが少しわかってしまいました。いや私も好きなんですけど。こういう普通に洒落カッコいい系統の曲、もっと作っていきたいですね。\n\nいい感じにまとまったところで裏設定を一つ思い出しました。それはBPMです。\n基本的に5の倍数にして綺麗な数値にしておこうと思ってたんですが、この曲だけ184とハンパになってます。\n理由はお察しの通り、高2の当時のプロジェクトファイルのテンポ設定がその値だったからです。そこまで再現したかった。",
        storyComment: "",
        storyEnd: "",
      },
      {
        url: "https://soundcloud.com/semicolon0103/asteroid-nekochan",
        src: require("../assets/musics/Asteroid_Nekochan.webp"),
        genre: "MUSIC GAME",
        color: "#039BE5",
        title: "Asteroid Nekochan",
        text: "宇宙っぽい合作曲",
        date: "2019",
        story: "Asteroid_Nekochan",
        artworkBy: "碧黴(あおかび)",
        artworkLink: "https://twitter.com/AokabiC",
        concept: "初の合作。スペースファンタジー感を出した上で冒険の始まりを感じさせる作品を目指した。\nまた音色も電子音の比率を減らし生音系統に寄せ、固い雰囲気を無くした曲調にした。",
        detail: [
          {
            label: "イントロ",
            description: "リバースピアノからスタート。当時の私の技術的にそれを作るのは無理だったけど、構想が降ってきたので何とかやってみた。\nまたその後に始まる、吟世かいな考案のsin波の旋律？に合わせコードを作った。\nこの時に準固有和音の使いどころを少し理解した気がする。\nこれから曲が始まる、盛り上がるような進行になったと思う。",
          },
          {
            label: "Aメロ(コード)",
            description: "当時は保続低音にハマっていたため、それで開始。\nまたその後に続く展開はその部分を発展させて作った。",
          },
          {
            label: "Aメロ(旋律)",
            description: "特に思いつかなかったのでコードを元にピアノを暴走させた。Nekochan曲なので。",
          },
          {
            label: "Bメロ",
            description: "吟世かいなから飛んできた旋律を元にコード進行を組んだ。\nただカノン進行をあてるのは勿体ないと思ったのでセカンダリードミナント?とかいろいろやって\n冒険の期待感とこれまでの旅路を振り返るノスタルジーを感じさせるコードを意識した。\nIIm→VM7の後にVm7を持ってきたが、ごちうさのサントラのFUN!FUN!にその該当箇所があり感動したので使わせてもらった。\nコード進行には著作権はない。アレンジ、かなりたのしかった\n私が組んだコード進行とともに旋律を鳴らした際の吟世かいなの驚く様子は正直嬉しかった。\n旋律は吟世かいならしさ100%の旋律。この頃は旋律が閃かなくて苦しんでいたので\n今後の私の旋律づくりに大きな影響を与えているのはここだけの話。",
          },
          {
            label: "サビ",
            description: "なんとなく金星の姿を思い浮かべながら、Bメロと同じように吟世かいなから飛んできた旋律を元に進行を組んだ。\n今でもそうだが半音で動かすのが好きなので、それを組み込んだ進行にした。\nまたバックのピアノ暴走はここに配置しろということで配置。ただ旋律の邪魔にならないよう緩急をつけた。\nずっと同じコード進行は芸がないということで、三週目の最後だけ変化を付けた。",
          },
          {
            label: "アウトロ",
            description: "イントロの展開をそのまま利用。このころは発想が乏しかったので同一曲内で上手に使いまわす方法を模索していた。\n最後のピアノの終わりとドラムのリズムはかなり気に入っている。",
          },
        ],
        storyMain: "学祭パッケージ、まさかの4曲目です。\n青葉台第一高校DTM部♪として何回か合作しようとしてて、一キロチーズピザをケチャップとかナツメグとかで食べた時に\n保続低音を使うことと曲の展開を決め、吟世かいなの撮りためてた旋律のうち良い感じなのを耳コピしたのがこの曲の生まれです。\nじゃあそれ以降何回か一緒に作業をしたかというとそれは違い、えいやって私が秒で作り上げた感じです。合作とは。\n以降、青葉台第一高校DTM部♪として何回か活動？してるんですが、曲作らずに毎回美味しいごはん食べてます。グルメか？\n\nジャケットですが、担当の碧黴(あおかび)曰く、スペースキャットっぽくなって難儀したとかなんとか。\n学祭の時の隠し曲になったんですが、特殊背景をつけてもらえるのはやはり嬉しいです。",
        storyComment: "",
        storyEnd: "",
      },
      {
        url: "https://soundcloud.com/semicolon0103/fierceness_re",
        src: require("../assets/musics/Fierceness.webp"),
        genre: "MUSIC GAME",
        color: "#039BE5",
        title: "Fierceness",
        text: "闇落ちあおは",
        date: "2019",
        story: "Fierceness",
        artworkBy: "いもねぎ",
        artworkLink: "https://twitter.com/imonegi_48",
        concept: "荒々しさを全面に出した、無窮動という言葉をまさに体現したような曲を目指した。\nまたBPMも250という、私の中で前代未聞の領域に挑戦した作品でもある。",
        detail: [
          {
            label: "イントロ",
            description: "ボイスロイド界隈?とかで有名な\"ヤツメ穴\"のイントロの進行が個人的にばっちり来たので使った。\nしかしそのまま使うのはあまりに芸が無いので、\n分数augを組み込めないかと思ったら予想外に面白くなったのでそれを採用した。\nまた、イントロの前半部はG#(5th)の音を全面に出し、\n後半部ではC#(主音)→F#(11th)と一気に広がっていくようにし曲の盛り上がりを表現した。\nなお最初の電子音みたいなヤツは意味もなく32分くらいの音符で散りばめた。\n環境音として配置したが上位譜面ではそれがなんとノーツに充てられていた。\nそこを音取りするのは作曲者の想定外でプレイヤーが押せるか不安だったが、\nどうやら人類は音ゲーが上手いようでそれは杞憂だった。すごい。",
          },
          {
            label: "Aメロ(コード)",
            description: "聞き返したところOperonのイントロと進行が一緒。\nシリアスっぽい雰囲気の進行は当時の私はそれしか引き出しが無かったのだろうか。\n二週繰り返すが、その繋ぎは分数augではなく裏コード?で上手く繋げられたと思う。\n二週目もトゥーファイブを用い目まぐるしく曲を展開させた。",
          },
          {
            label: "Aメロ(旋律)",
            description: "実はBayside Nekochanの時の旋律を元に作っており、歌心を掴むよう意識した。\nが、曲の雰囲気に徐々に引っ張られ、歌心というものは徐々に薄れピアノの暴走へ繋がる。",
          },
          {
            label: "Bメロ(コード)",
            description: "トゥーファイブを使って今度は転調をさせた。実はここも先述の\"ヤツメ穴\"に大きく影響を受けた箇所である。\nそうしたら行先を失いそうになったためドミナントモーションでとりあえずトニックに行きつくよう仕向けた。\nサビ前はドミナントで終えると決めていたので、\nドミナントは必ずaug系にすり替えられることからそこで分数augを決めた。",
          },
          {
            label: "Bメロ(旋律)",
            description: "前半部はAメロのピアノ暴走を引き継いだ。音の当て方は明文化すると長くなるので割愛。\n後半部の旋律はAメロの旋律を元に作り、曲の統一感を意識した。",
          },
          {
            label: "サビ",
            description: "Im→IIbm→Im→IVの動きを弾いたらなんとなく厳かだなと思ったので使った。ピアノもとにかく暴走させた。\nただそのまま16分で暴走させればいいわけではなくアウトロを経て曲は結ぶので、\n終わりにつれて音価?を長くしていくようにし、急停止感が無くなるように意識した。\nピアノ暴走は徐々に落ち着かせたがBPMは250を維持したままバッサリと停止。",
          },
          {
            label: "アウトロ",
            description: "BPMを一気に落としピアノのみのパートへ。ここは実際にピアノを弾きながら作った。\nまるで戦いを終えて勇ましく帰路に就く戦士の様な感じに仕上げた。majorコードでこの曲を締めたのは私の趣味。\nピカルディ終止?はエモくて好きなので。",
          },
        ],
        storyMain: "演奏(を聞きに行く)旅行に行こうとしてたら突然ラボの用事を図々しく入れられてキレたので、\nその勢いに任せて一気に作ったのがこれです。\n結果としてスケジュールが上手く噛み合い、旅行にもラボの用事にも両方出られることになったからよかったんですけど。\nBPMが250ということで普段の曲の展開数では曲の長さが短くなってしまう上に、\n16分で暴走させると速すぎて細かい音が潰れるということが分かったので、\n倍取りとかをしない場合で純粋に存在していいBPMの上限はこの辺りだなと思いました。\nクラシック音楽でもprestissimo(およそBPM210らしい)以上の速さの曲はあまり無いあたりそういうことでしょう。\nエクストラトーン？ちょっとよくわかりません\n\n会場は大阪だったんですが出発の当日19時まで研究室に拘束されたんですね。19時までと予定にあったのに終わる気配が皆無だったので、\n無断延長する方が悪いということで堂々と退出し青葉山駅に走り最終接続の新幹線に飛び乗ったのは懐かしい思い出です。\nそんな気分で車内でイヤホンでこの曲を聞いてると、新幹線のｺﾞｰｰｰｰという走行音と結構マッチして面白かったですね。\n\nジャケットにも裏設定があるらしく、いもねぎ曰く「ダークｱｵﾊﾁｬﾝ」とのこと。\n不敵な笑みを浮かべてるのが闇落ち?した私そっくりで気に入っています。\n赤紫に髪を染めてた訳ではありませんが乱視が進んだためメガネを新調し、そのメガネに変わってたりします。",
        storyComment: "",
        storyEnd: "",
      },
      {
        url: "https://soundcloud.com/semicolon0103/bayside-nekochan",
        src: require("../assets/musics/Bayside_Nekochan.webp"),
        genre: "MUSIC GAME",
        color: "#039BE5",
        title: "Bayside Nekochan",
        text: "夏全開って感じの",
        date: "2019",
        story: "Bayside_Nekochan",
        artworkBy: "umr",
        artworkLink: "https://twitter.com/BlazeConductor",
        concept: "院試を終えてストレスが消えたので、開放感に浸りたかったため楽しさ100%の曲を作りたかった。\nまた一小節内全てaug/分数augしか鳴らさない箇所を作ったりと、augの可能性を模索した。",
        detail: [
          {
            label: "イントロ(コード)",
            description: "楽しい感じを考えてたら降ってきた。特にVm→VIへの動きが個人的にグッとくると感じる。\nその後はクリシェっぽく上昇し分数aug。そこからはGの保続低音パートが始まりゆっくりと幕開け。\nプール前に準備体操するイメージ。\nちなみにここで分数augを使わないバージョンも作ったが、\n差し替えたところ一気に味気なくなったため、分数augの可能性に気づく。",
          },
          {
            label: "イントロ(旋律)",
            description: "前半部の旋律は降ってきたから詳細は不明だが、畳みかけるように盛り上がるように意識したつもり。\n後半部の旋律?は意識して13th辺りの音を使ってみた。\nD→Eの1オクターヴ以上の跳躍は飛び跳ねてる感じが出ると個人的には思い採用。\n音階上に存在しない音も散りばめているが、\nこういうところはしっかり音階から外した方がオシャレに楽しい感じが出ると思う。",
          },
          {
            label: "Aメロ(コード)",
            description: "後から聞き返すと基本的にイントロと似たコードを使っていた。\n特に深い意味はなくただ盛り上げたかっただけだろう。\n後半部は一旦盛り上がった前半部と対照的にゆっくりと下降。\nBメロで一旦静かにするための帳尻合わせ。",
          },
          {
            label: "Aメロ(旋律)",
            description: "私にしては珍しく口ずさみながら作った、というのは嘘で寝てたら降ってきた。\nこの頃に歌心をくすぐる旋律がどう構成されているかに気づいた気がする。\n後半部の音色は敢えてポルタメントを長め?に設定し、ふにゃふにゃした感じを出した。\nその方が羽目を外した楽しい感じが出ると思った。",
          },
          {
            label: "Bメロ(コード)",
            description: "トゥーファイブを使って落ち着いた感じを出した。\nその後、分数aug→aug→分数augというすごい1小節を経て、まるで飼い犬に「待て」をするようなパートへ。\n何もこの曲だけではないが、特にBメロの最後はドミナントで終えた方が\n基本的にサビへの盛り上がりに繋がると考えている。だからそうした。",
          },
          {
            label: "Bメロ(旋律)",
            description: "Aメロの旋律を元に作った。また進行がMaiden Nekochanのものと類似していたため、\nいかに旋律で差別化を図るか工夫したつもり。\n後半部のグロッケンは始まりの音と終わりの音を定めて逆算して配置。\n盛り上がりすぎず落ち着きすぎない中庸を目指した。",
          },
          {
            label: "サビ",
            description: "サビ入り前にホイッスルで曲を完全に仕切ってからピアノのグリッサンドから大暴走。\nコードがどうしてもMaiden Nekochanと似てしまうと感じたため、\nビーチっぽい楽しさは半音を上手く使った旋律が鍵だと考え、そっちでカバーし前作との差別化を図った。",
          },
          {
            label: "アウトロ",
            description: "イントロ後半の分数augを使わないバージョンでアウトロを始めた。とはいっても以降の内容はイントロ後半と同一。\nこの頃は発想力やストックに乏しく、アウトロを2回繰り返したり曲パートを使いまわしたりすることが多かった気がする。",
          },
        ],
        storyMain: "院試が終わった開放感で本当にすぐに作りましたね。\n丁度8月下旬頃で完全に街は夏。夏に開放感と行ったらビーチっぽい雰囲気だと思います。\nいろいろと何も考えずにいつも曲を作っていますが、今作も楽しさ一点に絞った曲なので、何も考えていません。\nDETAIL節で理屈っぽいこと書いていますが大半は後付けです。\n\n今作では特にaugの模索に成功したのが一番の収穫でした。\nというのも普段からピアノロールでいろいろコードをいじって経験で何かを感じ取ってたからだと思います。\n対照実験ではありませんが、普通のコード(?)にすり替えた版と聞き比べることでその効果に気づけました。\n一般に不協和音と言われるものもスパイス的な感じでなくてはならない存在になり得るんだと確信を持ちました。\n\n今作はむしろジャケットに関する裏話が大きく、\nそれもジャケット担当者からファンアートという形でこのジャケットが爆速で送られてきたんです。\nまさか自分の曲をそんなに気に入ってくださるとは。恐縮の一言に尽きましたが、この時の嬉しさは今でも忘れられません。\nなんせ丁度この一年前は神経痛を発症するくらい作曲で散々嫌な思いをしていたので。人生本当に何があるか分かりません。\n後日聞いた話ですが、\"Bayside Nekochan\"の文字はフォントがあったものの\"相生あおは\"の日本語フォントがなかったとかで、\n手書きトレースして文字入れしてくれたとかなんとか。そこまでしてくれてたなんて…\n\nBaysideという曲名ですが、作った当時はSeasideにする予定でした。\nしかし、響きがsuicideっぽい上にそもそもSから始まる単語は意外に多いことに気づき、\nSkyとかSpaceといった単語を今後使えなくなるというのは困るということでBaysideにしたというエピソードもあります。\n実際にこの一年後にSkyhigh Nekochanを書いてますし、その時に過去の自分に感謝したので、計画通りです。\nそういえば言ってませんでしたね。曲名は基本的にNekochanシリーズ・非Nekochanシリーズともに\n頭文字が重複しないようにしています、フォルダソートした時に見やすいので。\nなので26x2=52曲を作り切ったら…その時はどうするんでしょうね。\nただ一つ言えるのはマルチバイト文字は決して使わないということ。文字化けが死ぬほど嫌いなので。",
        storyComment: "",
        storyEnd: "",
      },
      {
        url: "https://soundcloud.com/semicolon0103/contemplation",
        src: require("../assets/musics/Contemplation.webp"),
        genre: "MUSIC GAME",
        color: "#039BE5",
        title: "Contemplation",
        text: "院試勉強で人生諦観してた",
        date: "2019",
        story: "Contemplation",
        artworkBy: "蛇路",
        artworkLink: "",
        concept: "院試勉強をしすぎて心を壊して生きる宛てを見失いまたメンタルが壊れてたので、それを曲にした。\nただ一周回って人生を諦観していた時期だったのでゆったりとした曲に仕上げた。\nまたこの頃ドビュッシーにハマってたのでとにかく全音音階を使おうとした。\nしかし使い慣れてなかったためところどころ違和感が出る曲になってしまった。",
        detail: [
          {
            label: "イントロ",
            description: "ダンスチックのゆったりとしたBPM、雰囲気のピアノの曲の案が降ってきたのでそれをそのまま形にし、\n答えに行きつかないようなふわふわとしたイントロに仕上げた。\n旋律も宛てもない感じで動かした。",
          },
          {
            label: "Aメロ(コード)",
            description: "よく使われてるようなコードとクリシェを組み合わせた。またトゥーファイブを使い転調させた。",
          },
          {
            label: "Aメロ(旋律)",
            description: "流れるように歌えるような旋律を意識した。このころから歌心を意識した旋律を作るように工夫をするようになった。",
          },
          {
            label: "サビ(コード)",
            description: "主調のBb majorからDb majorへ転調し、保続低音をつかいコード自体はまたクリシェ。あまり動きを作らないよう意識した。",
          },
          {
            label: "サビ(旋律)",
            description: "Aメロ部で発想が尽きてしまったので、またまた掛け合わせを意識して作った。ただ思いつかなかったので作るのが苦しかった。",
          },
          {
            label: "アウトロ",
            description: "ここでも保続低音を使い静かに終わる。旋律も目立った動きをしないで最後はピアノで静かに終える。\n屋上で物思いに耽った後、作業に戻るため部屋に降りていく、そんな気分を描写した。",
          },
        ],
        storyMain: "Highspeed Nekochanとは別な意味で何も考えずに作った曲でした。その時の気分をそのまま曲にしました。\nなので、またまた曲の展開が新規開拓状態になっています。自分で聞き返したところ、Bメロがないことに気づいたんですよね。\n曲の構成に正解ってあるわけないし後悔していないし誰にも文句言われる筋合いは無い。\nただ全音音階を使い慣れてないのにふんだんに使ったせいで違和感がある箇所が出来てしまいました。そこは反省してます。\n\nよく言われたことは、「そんな作曲背景にしては落ち着いた曲だね」ってことです。でも諦めたらみんなこんな気分になると思います。きっと\nジャケットに関しては、お願いした通りのものを作っていただきました。この曲を絵にするならまさにこんな感じでしょう。\nあと間違えないで欲しいんですが、その後にここから飛び降りるみたいな裏設定はありません。\n絶望的・悲劇的な情景を敢えて長調で書くこともありますがここにはそんな意図はありません。",
        storyComment: "",
        storyEnd: "",
      },
      {
        url: "https://soundcloud.com/semicolon0103/maiden-nekochan",
        src: require("../assets/musics/Maiden_Nekochan.webp"),
        genre: "MUSIC GAME",
        color: "#039BE5",
        title: "Maiden Nekochan",
        text: "乙女心みたいな",
        date: "2019",
        story: "Maiden_Nekochan",
        artworkBy: "いもねぎ",
        artworkLink: "https://twitter.com/imonegi_48",
        concept: "春パッケージの曲ということで春をテーマ。春と言ったら出会いと別れ。\nMelancholyもそうでしたが情景を描写する曲を作ろうと考えたため、\n気晴らしとして恋する初々しい乙女心をそのまま描写する曲を作った。",
        detail: [
          {
            label: "イントロ(コード)",
            description: "新規路線を開拓しようと、ドミナントから始まるコードにしようとした。\nそこから徐々に下がって行って分数augを使ったり、二週目はコードを変化させたり。\nAメロに繋がる場所はオンコードを使いアニメのOP感が出るよう意識した。",
          },
          {
            label: "イントロ(旋律)",
            description: "基本的に音の高低が変わらない旋律は作らなかったが、\n歌ものを意識する場合は意外とアリなのではということで採用。\n二週目は一週目とわずかに変えて飽きを防止。\nなかなかIに行きつかない進行を歯切れのよいリズムで区切り、\nトランペットでアニソン感を出した。旋律も掛け合わせを意識し、とにかく明るい雰囲気にした。",
          },
          {
            label: "Aメロ(コード)",
            description: "実はコード自体は海洋生物たちの復讐2( https://www.freem.ne.jp/win/game/19923 )で担当したstage5の原案BGMと全く同一。\nただその原案BGM自体は没にしたのでどこでも聞けないんだけど。\nさわやかな進行で気に入ってたんだけどまぁここでリベンジ。",
          },
          {
            label: "Aメロ(旋律)",
            description: "旋律なんてものはない。ピアノをいろいろやってNekochanシリーズっぽく16分で暴走。",
          },
          {
            label: "Bメロ(コード)",
            description: "前半部分はトゥーファイブでゆったりと流し、\n後半部分は分数augを使いながら沈ませ、勇気が出ず決心が揺らぐ心情を描写。",
          },
          {
            label: "Bメロ(旋律)",
            description: "掛け合わせを意識しただけでコードに合うように辻褄合わせ。\n後半部分のピアノは結構気に入ってる。自分が弾くならこう弾くという意図で配置した。",
          },
          {
            label: "サビ(コード)",
            description: "イントロ同様ドミナントから始まるコードを使った。\n前半部はありきたりだと思うが後半部はどこかで聞いたことあるような\"それっぽい\"進行を意識し、\nそれに加えサビ最後に向かうにつれてとにかく上昇させ、高揚感を表現。",
          },
          {
            label: "サビ(旋律)",
            description: "Bメロ最後のピアノの流れをそのまま引き継ぎ「さあ突っ走れ！」を実感できるピアノ暴走を目指した。\nちなみに今後のNekochanシリーズのピアノ暴走の方針はこの曲で確立した。",
          },
          {
            label: "アウトロ",
            description: "特に思いつかなかったのでイントロの後半部分をそのまま利用。\n最初は手抜きだと思い気に入らなかったが、再利用は意外と統一感が出てよいのではと完成後に思った。\n最後の部分は敢えて割り切れない和音にし、想いが伝わったのかはまだわからないという雰囲気を目指した。",
          },
        ],
        storyMain: "楽しい曲を作りたかったんです。気分は沈んでいたんですが負けていられないと思い春パッケージも2曲参戦にしました。\n雰囲気としては、なんかわちゃわちゃした学園ものアニメのOP感を目指しました。\n特にイントロとアウトロで入るトランペットの合いの手が、とても\"それっぽい\"んじゃないでしょうか。\n\n実は裏話が2つあって、1つは当初アウトロがワンコーラスだけだったという点です。\nただそれだと規定時間に入らなかったのでもう一度繰り返したという次第。\nこう考えると曲の展開を考える能力はあまりないですね。ただ、使いまわす場合どう変化させるかを学ぶことができたかと思います。\n2つ目は曲名に関してで、最初はまたドイツ語で乙女心を意味した単語にしてました。\nただなんか微妙だったのでMaiden Nekochanにし、Nekochanシリーズというものがここで完全に確立しました。\nジャケット描いてくれたいもねぎも最初は「曲名がドイツ語ということで金髪にした」といってたんですが、\n曲名を英語に変えてメガネも当時私が掛けていたものをモチーフにするということになったので、髪はこげ茶髪になりました。\n服装はこの年の夏ごろに結成?する青葉台第一高校の制服という設定です。たぶん。あ、襟と袖のラインが2本になってるじゃん…\n\nジャケットに関する裏話ですが、左上のエンブレムの上部にあひるが紛れています。探してみてください。",
        storyComment: "",
        storyEnd: "",
      },
      {
        url: "https://soundcloud.com/semicolon0103/melancholie",
        src: require("../assets/musics/Melancholy.webp"),
        genre: "MUSIC GAME",
        color: "#039BE5",
        title: "Melancholy",
        text: "曲名通りの曲",
        date: "2019",
        story: "Melancholy",
        artworkBy: "碧黴(あおかび)",
        artworkLink: "https://twitter.com/AokabiC",
        concept: "私事情でメンタルが酷く落ち込んでおり、当時の心象風景をそのまま曲に描写した。\nまた、当時分数augを知り使いたがろうとしたが上手く決まらなかった。\nただ沈んた雰囲気ではなく、物思いに耽ったり困難を乗り越え強く生きようという曲に仕上げた。",
        detail: [
          {
            label: "イントロ",
            description: "ピアノのリズミカルな曲の構想が降ってきたのでそれをそのまま形に。\n当時は何か旋律を付けようと考えたがどれも今一つだったため、旋律は使わないという当時としては初の試みに出た。\n基本的な進行を徐々に崩していき、分数augを経てAメロへ。",
          },
          {
            label: "Aメロ(コード)",
            description: "あまり動きが出ない進行を意識。\n後半部ではトゥーファイブ?っぽい堅い動きを使い、あまり感情を揺さぶらない曲風を意識した。",
          },
          {
            label: "Aメロ(旋律)",
            description: "物思いに耽るメロディを意識。\n前からよく使っていた半音で旋律を動かす手法をふんだんに使用。雰囲気に合ったと思う。",
          },
          {
            label: "Bメロ(コード)",
            description: "ひたすら下降。思慮に耽っている時ってこんな感じになるかと。",
          },
          {
            label: "Bメロ(旋律)",
            description: "主旋律と副旋律を用いて切なげなメロディを意識した。\n実は最後の方でOperonの主旋律を鳴らしている。",
          },
          {
            label: "サビ(コード)",
            description: "闇に魘される情景を描写。よく聞くとOperonと進行が非常に似ている。\nこういう曲を作るのは慣れてなかったので、上手く決まった曲に大きく影響を受けたのかもしれない。",
          },
          {
            label: "サビ(旋律)",
            description: "主旋律(sax&cl)で魘されながらも存在する心の芯を感じられる堅実な旋律を流し、\n一応音ゲー曲になるのでリコーダーで暴走。",
          },
          {
            label: "アウトロ",
            description: "分数augを使ってみたかっただけの箇所。最後はF majorになり将来への決心を描写した。\n旋律も掛け合わせを意識してコードに合うように組んだため深い意味は無い。",
          },
        ],
        storyMain: "私事情については触れませんが、そういう時こそ心象風景を描写する曲を作るチャンスではないかと考えました。\nこう考えてみると少しサイコパスかもしれません。\nまた分数augについては、ここをお読みの方ならご存じでしょう、私もそれを使ってみたかったんです。\n解説は省きますが扱いが若干特殊な和音なため、知見が無かった私は手探り状態で最適解を探したんです。\n結果、普通のaugとの差別化ができずに上手く決めることができなかったんです。\n少し苦い思い出がある曲ですが心象の描写は上手くできたと思います。\n曲名に関しても、最初はまたドイツ語で憂鬱を意味する単語にしようとしたんですが、英語と変わりなかったため英語にしました。\nこの頃に、非Nekochan曲の曲名は英語として一単語にするというスタイルが確立しました。",
        storyComment: "",
        storyEnd: "",
      },
      {
        url: "https://soundcloud.com/semicolon0103/hispeed-nekochan",
        src: require("../assets/musics/Highspeed_Nekochan.webp"),
        genre: "MUSIC GAME",
        color: "#039BE5",
        title: "Highspeed Nekochan",
        text: "ノリと勢いだけで作った",
        date: "2018",
        story: "Highspeed_Nekochan",
        artworkBy: "相生あおは",
        artworkLink: "https://twitter.com/semicolon0103",
        concept: "なんか出来上がってしまった問題作。\n京音の方が作ったk-shoot mania( https://www.kshootmania.com/ )のIN譜面が発狂難易度表に入って話題になってしまった。\n話題に上がるたびにごめんなさいって言ってるのはここだけの話。",
        detail: [
          {
            label: "イントロ・Aメロ(コード)",
            description: "イントロ、とは…？ただドリアを鳴らしてるだけ。",
          },
          {
            label: "イントロ・Aメロ(旋律)",
            description: "実はこの曲は旋律先行。IdealMemoria( https://www.freem.ne.jp/win/game/19807 )で担当してたBGMの旋律をデフォルメしてそのまま作った。ごめんなさい",
          },
          {
            label: "Bメロ(コード)",
            description: "旋律をあまり変えずコードを一変させる。\nこの曲の主調はドリアとはいえD minorの部類で\nこの部分はB minor。無理くり用語をあてるなら平行同主調への転調かと。",
          },
          {
            label: "Bメロ(旋律)",
            description: "展開が閃かなかったのでとにかく音を付加していった。\nすると曲が迷子になったので全音音階を強引に使いゴリ押し。\nこの部分、作ってる本人でもマジで意味不明になってしまったので、\nサビ?につながるところこそは安定感出さないと流石に問題なので、大正義ドミナントモーションに頼った。",
          },
          {
            label: "サビ?",
            description: "コードをまず決めた。単純明快なものになっているはず。\nただ旋律を決める能力が足りなかったためピアノを暴走させた。\nその結果、発狂難易度にランクイン。\nNekochanシリーズの基礎は実はこんなきっかけで確立する。\n人生何があるか分からない。\n\nアウトロ?そんなものはない。",
          },
        ],
        storyMain: "強い覚悟を決めて作ったOperonとは違い、惰性で作ったんですね。\nこの年の3月に人生初のインフルエンザに罹っており、その時に降ってきたコード進行がBメロ前半のものでした。\nつまりその在庫処分セールです。旋律もIdealMemoriaのものと似てますし本当にごめんなさい。\nでも作曲者が一緒なので怒られることは無いでしょう。\nゲームのBGMを作ってると脳裏からメインモチーフが離れないんですよ。だから使ってしまった。\n当初はOperonだけ参加予定だったんですが急遽2曲目参加の打診をしたのが懐かしい。\n\nこの曲もOperon並に酷い裏話が2つあります。\nそれは曲名を決めるときの話です。マジで何も考えずに作り上げたので、\n「どこかの国の言語で脳死を意味する単語にしよう」と考えたんです。\nスワヒリ語やタガログ語を試したがイマイチ。んで一旦ドイツ語にしたんです。\n曲名が決まったタイミングで友人と相談したところ、「どういう意味？」と氏がその単語を検索してしまったんです。\nドイツ語で脳死、すなわち医療系のそういう画像が出てきたので2人のSAN値がピンチになってしまいました。最悪。\n流石に問題だということで、当時Twitterの内輪で流行ってたHighspeed Nekochanが頭悪そうで良いなということで安易に採用。\n後付けですが、サビ部分のピアノ暴走がHighspeedなNekochanみたいでいいよね！ということで最終決定に至ったんです。\n曲名はしっかり考えようという教訓を得ました。\n当時、この曲を皮切りにNekochanシリーズが確立し、何曲と続いていくとは誰に想像できよう。\n\nあとですね、幻のジャケットがあったんです。それは仙台市営バスの青葉台バス停の写真を加工したもの。\nそれもなんと、学祭の展示に使うということでわざわざ仙台市交通局に許可を得たのでお墨付き。\n当初はそのまま公開しても良いと言われたんですが、パッケージとして公開する前に念のため確認したら\n担当者が変わってて「いやちょっと…」と言われてしまいました。\nそこで、バス停の画像を私のTwitterアイコンにそのまますり替えたものが今のジャケットとなります。\nただ、先述の通りこのあと何曲もNekochanシリーズが続き、その記念すべき一曲目ということになったので、\nそこは私のアイコンの方が適してるじゃんって今思い返すとそう思います。結果オーライ。",
        storyComment: "",
        storyEnd: "",
      },
      {
        url: "https://soundcloud.com/semicolon0103/operon_re",
        src: require("../assets/musics/Operon.webp"),
        genre: "MUSIC GAME",
        color: "#039BE5",
        title: "Operon",
        text: "作曲引退を賭けて作った",
        date: "2018",
        story: "Operon",
        artworkBy: "いもねぎ",
        artworkLink: "https://twitter.com/imonegi_48",
        concept: "初めて作った非BGM曲であったため、曲の構成・展開を厳格に定め安定した進行を目指した。\nまた、一度使った進行は再現部以外二度と使わないという縛りを設け自らの発想力を試した。\n曲名は後付けで、各コード進行を遺伝子の転写単位に例えてOperonとした。\n" + "おたくは自分の専門分野の単語を曲名につけがち。".strike(),
        detail: [
          {
            label: "イントロ(コード)",
            description: "何も考えずにカノン進行っぽいヤツを採用。\nまたこの進行を二回繰り返すが、次のAメロに繋がるようにわずかに加工し、EMを鳴らし曲に読点を打った。",
          },
          {
            label: "イントロ(旋律)",
            description: "近い音の羅列と跳躍した音を規則的に用いた。\nコード進行と同じく繰り返すが、これから曲が始まるという期待感を出すために\n後半部では徐々に上昇させ、EではなくBで結び半終止感を出した。",
          },
          {
            label: "Aメロ(コード)",
            description: "1,4,5を繰り返しカノン進行へ。さっそくコンセプトを崩してしまい、すいません。\n例にもよってこの進行を二回繰り返すが、次のBメロに繋がるようにわずかに加工し、F#mを鳴らし一度終止させた。",
          },
          {
            label: "Aメロ(旋律)",
            description: "コードが1,4,5となってる箇所は、盛り上がりと落ち着きを繰り返す音階を選んだ。\nこれはその後のカノン進行部分でも同じで、イントロの旋律を元に組んだ。\n後半部では徐々に上昇させ、F#でコードと併せて終止させた。",
          },
          {
            label: "Bメロ(コード)",
            description: "恐らくトゥーファイブと呼ばれるらしいもので進めた。\nあとはひたすら変えたりしたり。あまり盛り上がらないような進行を意識した。\nその後にサビとなるため、強引にドミナントモーションに繋がるようにいじくった。",
          },
          {
            label: "Bメロ(旋律)",
            description: "2つのシンセリードが掛け合わせになるように組んだ。\nイントロの旋律が個人的にも決まったと感じていたため、それを意識した。\n旋律も同様に盛り上がりを感じさせる終わり方を意識した。",
          },
          {
            label: "サビ(コード)",
            description: "ひたすら上昇させ高揚感を出した。\n2回目に繰り返す際は飽きさせないため鋭いリズムで刻み、その後Bb majorで結ぶような雰囲気を出した。\n当初はここで曲を終える予定だったが微妙だったため次に続く。",
          },
          {
            label: "サビ(旋律)",
            description: "ここも掛け合わせを意識した旋律づくりをした。\n基本的にコードに合うような音を当てたため深い意味はない。",
          },
          {
            label: "Cメロ?",
            description: "コードはゆったりと上昇させ、Bb majorから主調のF# minorに強引に転調させるためになんかやった。\n旋律も掛け合わせを意識したまま以下略。\nこの部分はただの辻妻合わせなので深い意味は無い。",
          },
          {
            label: "再現部?",
            description: "一般的な音ゲー曲はこういう構成ではないことを後に知った。\nでも再現部って、初期メンバーの帰還感が出てエモ味出るのでは？ということでこういう構成にした。\n結果として2分半越えという長さになってしまい、すいません。\n当時は長さ規定まだなかったから多分許される。",
          },
          {
            label: "Dメロ?",
            description: "用語が分からない。とにかく最後の大サビに持っていく繋ぎ。",
          },
          {
            label: "大サビ(コード)",
            description: "単なる上昇進行を再度使用するのはあんまりに芸が無くて嫌だったので、\nセカンダリードミナント?を使用し一般的に\"泣きメロ\"と言われるような進行にした。\ndim7からのマイナーコードみんな好きでしょ",
          },
          {
            label: "大サビ(旋律)",
            description: "コード進行先行で何も考えていなかったため、とりあえずピアノを16分音符で並べた。\n実はこれが後のNekochanシリーズの源流である。\n副旋律も鳴らしており、ピアノの暴走と対照に長い音価で構成させ調和を狙った。",
          },
          {
            label: "アウトロ(コード)",
            description: "4,5,1の進行に半音進行?を組み込みとにかくコンセプトを守ろうとした。\nまた、まだドミナントの状態で一旦曲を切り、最後に派手にピアノをどしーんと決めて力強く終止。\n最後のピアノの音、11thまで付加してるのは若気の至り。許してください。",
          },
          {
            label: "アウトロ(旋律)",
            description: "旋律のネタが降ってこなかったのでコード進行の帳尻合わせで適当に掛け合わせて作った。",
          },
        ],
        storyMain: "この頃は作曲に対する自信を完全に失っていた時期でした。\n友人の誘いでとんえぼに入った際のデビュー作で、\nこの曲が受け入れられなかったら本当に作曲をやめるという強い覚悟で送り出した一曲だったりします。\nDETAILで書いた\"適当に\"という言葉は、言語化するのが面倒だったという意味で賽を投げて作曲したわけではありません。\n結果としてわりと好評だったそうで。各位には本当に感謝しかありません。\nくだらない裏話が実は2つ存在して、その一つが当初BPM176で3分越えの曲だった( https://soundcloud.com/semicolon0103/operon_original )ということ。\n\n当時は音ゲーマーではなくBPMが180を越す曲を作ったことがなかったんですね。\nそこで友人(音ゲーマー)に聞かせたところ「あまりに長い」と言われ(当然)、1回目のサビで曲を切断することも検討したが、\n個人的に再現部と大サビがとても気に入っていたため何も考えずにそのままBPMを205にぶち上げたという裏話があります。\nこのBPMに設定したのは、5の倍数かつ聞こえがマシと感じた値だったからです。\nまたこの時点ではまだ曲名は決まっておりませんで、困った挙句にBPMが205なのを良いことに\n仙台市営バス205系統の行先である高砂市営住宅西という曲名にしようとしたら友人に止められたという裏話もあります。\nなのでOperonという曲名はかな～り後になって付けられたんです。\n\nジャケットですが、4種の塩基に二重らせん構造、それにセントラルドグマをイメージした9みたいなリングは私からの注文だったりします。\n細かすぎて伝わりませんね。",
        storyComment: "",
        storyEnd: "",
      },
    ],
  }),
  methods: {
    TextDecorate(text) {
      return typeof(text) === "string" ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'>Link</a>") : '';
    }
  },
  computed: {
    content() {
      const filter = this.musics.filter((music) => music.story === this.$route.params.id);
      return filter;
    },
  },
}
</script>

<style scoped>
.top-slides-bg-circles {
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.top-slides-bg-circles li {
  position: absolute;
  overflow: hidden;
  display: block;
  list-style: none;
  width: 20px;
  height: 20px;
  background: #f8c6c6;
  opacity: 0;
  animation: animate 25s linear infinite;
}
.top-slides-bg-circles li:nth-child(1) {
  left: 25%;
  width: 80px;
  height: 80px;
  animation-delay: 0s;
}
.top-slides-bg-circles li:nth-child(2) {
  left: 10%;
  width: 20px;
  height: 20px;
  animation-delay: 2s;
  animation-duration: 12s;
}
.top-slides-bg-circles li:nth-child(3) {
  left: 70%;
  width: 20px;
  height: 20px;
  animation-delay: 4s;
}
.top-slides-bg-circles li:nth-child(4) {
  left: 40%;
  width: 60px;
  height: 60px;
  animation-delay: 0s;
  animation-duration: 18s;
}
.top-slides-bg-circles li:nth-child(5) {
  left: 65%;
  width: 20px;
  height: 20px;
  animation-delay: 0s;
}
.top-slides-bg-circles li:nth-child(6) {
  left: 75%;
  width: 110px;
  height: 110px;
  animation-delay: 3s;
}
.top-slides-bg-circles li:nth-child(7) {
  left: 35%;
  width: 150px;
  height: 150px;
  animation-delay: 7s;
}
.top-slides-bg-circles li:nth-child(8) {
  left: 50%;
  width: 25px;
  height: 25px;
  animation-delay: 15s;
  animation-duration: 45s;
}
.top-slides-bg-circles li:nth-child(9) {
  left: 20%;
  width: 15px;
  height: 15px;
  animation-delay: 2s;
  animation-duration: 35s;
}
.top-slides-bg-circles li:nth-child(10) {
  left: 85%;
  width: 150px;
  height: 150px;
  animation-delay: 0s;
  animation-duration: 11s;
}
.top-slides-bg-circles2 {
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.top-slides-bg-circles2 li {
  position: absolute;
  overflow: hidden;
  display: block;
  list-style: none;
  width: 20px;
  height: 20px;
  background: #adb9de;
  opacity: 0;
  animation: animate 25s linear infinite;
}
.top-slides-bg-circles2 li:nth-child(1) {
  left: 80%;
  width: 80px;
  height: 80px;
  animation-delay: 6s;
}
.top-slides-bg-circles2 li:nth-child(2) {
  left: 55%;
  width: 20px;
  height: 20px;
  animation-delay: 0s;
  animation-duration: 14s;
}
.top-slides-bg-circles2 li:nth-child(3) {
  left: 30%;
  width: 20px;
  height: 20px;
  animation-delay: 16s;
}
.top-slides-bg-circles2 li:nth-child(4) {
  left: 15%;
  width: 60px;
  height: 60px;
  animation-delay: 4s;
  animation-duration: 16s;
}
.top-slides-bg-circles2 li:nth-child(5) {
  left: 40%;
  width: 20px;
  height: 20px;
  animation-delay: 0s;
}
@keyframes animate {
  0% {
    transform: translateY(1000px) rotate(0deg);
    opacity: 0.4;
    border-radius: 20%;
  }
  100% {
    transform: translateY(-1000px) rotate(720deg);
    opacity: 0.2;
    border-radius: 40%;
  }
}
</style>
